const tokens = {
  "colors.current": {
    "value": "currentColor",
    "variable": "var(--colors-current)"
  },
  "colors.black": {
    "value": "#000000",
    "variable": "var(--colors-black)"
  },
  "colors.white": {
    "value": "#ffffff",
    "variable": "var(--colors-white)"
  },
  "colors.transparent": {
    "value": "rgb(0 0 0 / 0)",
    "variable": "var(--colors-transparent)"
  },
  "colors.blue.0": {
    "value": "#FFFFFF",
    "variable": "var(--colors-blue-0)"
  },
  "colors.blue.50": {
    "value": "#F3F9FF",
    "variable": "var(--colors-blue-50)"
  },
  "colors.blue.100": {
    "value": "#DBEEFF",
    "variable": "var(--colors-blue-100)"
  },
  "colors.blue.150": {
    "value": "#C2E3FF",
    "variable": "var(--colors-blue-150)"
  },
  "colors.blue.200": {
    "value": "#AAD7FF",
    "variable": "var(--colors-blue-200)"
  },
  "colors.blue.250": {
    "value": "#92CCFF",
    "variable": "var(--colors-blue-250)"
  },
  "colors.blue.300": {
    "value": "#79C0FF",
    "variable": "var(--colors-blue-300)"
  },
  "colors.blue.350": {
    "value": "#61B5FF",
    "variable": "var(--colors-blue-350)"
  },
  "colors.blue.400": {
    "value": "#49AAFF",
    "variable": "var(--colors-blue-400)"
  },
  "colors.blue.450": {
    "value": "#319EFF",
    "variable": "var(--colors-blue-450)"
  },
  "colors.blue.500": {
    "value": "#1893FF",
    "variable": "var(--colors-blue-500)"
  },
  "colors.blue.550": {
    "value": "#0087FF",
    "variable": "var(--colors-blue-550)"
  },
  "colors.blue.600": {
    "value": "#007AE7",
    "variable": "var(--colors-blue-600)"
  },
  "colors.blue.650": {
    "value": "#006ECE",
    "variable": "var(--colors-blue-650)"
  },
  "colors.blue.700": {
    "value": "#0061B6",
    "variable": "var(--colors-blue-700)"
  },
  "colors.blue.750": {
    "value": "#00549E",
    "variable": "var(--colors-blue-750)"
  },
  "colors.blue.800": {
    "value": "#004786",
    "variable": "var(--colors-blue-800)"
  },
  "colors.blue.850": {
    "value": "#003A6D",
    "variable": "var(--colors-blue-850)"
  },
  "colors.blue.900": {
    "value": "#002D55",
    "variable": "var(--colors-blue-900)"
  },
  "colors.blue.950": {
    "value": "#00203D",
    "variable": "var(--colors-blue-950)"
  },
  "colors.blue.1000": {
    "value": "#001324",
    "variable": "var(--colors-blue-1000)"
  },
  "colors.coal.0": {
    "value": "#FFFFFF",
    "variable": "var(--colors-coal-0)"
  },
  "colors.coal.50": {
    "value": "#F5F5F5",
    "variable": "var(--colors-coal-50)"
  },
  "colors.coal.100": {
    "value": "#F0F0F0",
    "variable": "var(--colors-coal-100)"
  },
  "colors.coal.150": {
    "value": "#E7E7E7",
    "variable": "var(--colors-coal-150)"
  },
  "colors.coal.200": {
    "value": "#DEDEDE",
    "variable": "var(--colors-coal-200)"
  },
  "colors.coal.250": {
    "value": "#D4D4D4",
    "variable": "var(--colors-coal-250)"
  },
  "colors.coal.300": {
    "value": "#CACACA",
    "variable": "var(--colors-coal-300)"
  },
  "colors.coal.350": {
    "value": "#C1C1C1",
    "variable": "var(--colors-coal-350)"
  },
  "colors.coal.400": {
    "value": "#B7B7B7",
    "variable": "var(--colors-coal-400)"
  },
  "colors.coal.450": {
    "value": "#AEAEAE",
    "variable": "var(--colors-coal-450)"
  },
  "colors.coal.500": {
    "value": "#727272",
    "variable": "var(--colors-coal-500)"
  },
  "colors.coal.550": {
    "value": "#676767",
    "variable": "var(--colors-coal-550)"
  },
  "colors.coal.600": {
    "value": "#5C5C5C",
    "variable": "var(--colors-coal-600)"
  },
  "colors.coal.650": {
    "value": "#515151",
    "variable": "var(--colors-coal-650)"
  },
  "colors.coal.700": {
    "value": "#464646",
    "variable": "var(--colors-coal-700)"
  },
  "colors.coal.750": {
    "value": "#3B3B3B",
    "variable": "var(--colors-coal-750)"
  },
  "colors.coal.800": {
    "value": "#313131",
    "variable": "var(--colors-coal-800)"
  },
  "colors.coal.850": {
    "value": "#272727",
    "variable": "var(--colors-coal-850)"
  },
  "colors.coal.900": {
    "value": "#1C1C1C",
    "variable": "var(--colors-coal-900)"
  },
  "colors.coal.950": {
    "value": "#050505",
    "variable": "var(--colors-coal-950)"
  },
  "colors.coal.1000": {
    "value": "#000000",
    "variable": "var(--colors-coal-1000)"
  },
  "colors.cyan.0": {
    "value": "#FFFFFF",
    "variable": "var(--colors-cyan-0)"
  },
  "colors.cyan.50": {
    "value": "#F3FCFE",
    "variable": "var(--colors-cyan-50)"
  },
  "colors.cyan.100": {
    "value": "#DCF6FC",
    "variable": "var(--colors-cyan-100)"
  },
  "colors.cyan.150": {
    "value": "#C5F0FA",
    "variable": "var(--colors-cyan-150)"
  },
  "colors.cyan.200": {
    "value": "#ADEAF7",
    "variable": "var(--colors-cyan-200)"
  },
  "colors.cyan.250": {
    "value": "#96E4F5",
    "variable": "var(--colors-cyan-250)"
  },
  "colors.cyan.300": {
    "value": "#7FDEF3",
    "variable": "var(--colors-cyan-300)"
  },
  "colors.cyan.350": {
    "value": "#67D8F1",
    "variable": "var(--colors-cyan-350)"
  },
  "colors.cyan.400": {
    "value": "#50D2EF",
    "variable": "var(--colors-cyan-400)"
  },
  "colors.cyan.450": {
    "value": "#39CBEC",
    "variable": "var(--colors-cyan-450)"
  },
  "colors.cyan.500": {
    "value": "#21C5EA",
    "variable": "var(--colors-cyan-500)"
  },
  "colors.cyan.550": {
    "value": "#15B9DE",
    "variable": "var(--colors-cyan-550)"
  },
  "colors.cyan.600": {
    "value": "#13A5C6",
    "variable": "var(--colors-cyan-600)"
  },
  "colors.cyan.650": {
    "value": "#1092AF",
    "variable": "var(--colors-cyan-650)"
  },
  "colors.cyan.700": {
    "value": "#0E7E98",
    "variable": "var(--colors-cyan-700)"
  },
  "colors.cyan.750": {
    "value": "#0C6B80",
    "variable": "var(--colors-cyan-750)"
  },
  "colors.cyan.800": {
    "value": "#0A5769",
    "variable": "var(--colors-cyan-800)"
  },
  "colors.cyan.850": {
    "value": "#084452",
    "variable": "var(--colors-cyan-850)"
  },
  "colors.cyan.900": {
    "value": "#05313A",
    "variable": "var(--colors-cyan-900)"
  },
  "colors.cyan.950": {
    "value": "#031D23",
    "variable": "var(--colors-cyan-950)"
  },
  "colors.cyan.1000": {
    "value": "#010A0C",
    "variable": "var(--colors-cyan-1000)"
  },
  "colors.gray.0": {
    "value": "#FFFFFF",
    "variable": "var(--colors-gray-0)"
  },
  "colors.gray.50": {
    "value": "#F5F5F5",
    "variable": "var(--colors-gray-50)"
  },
  "colors.gray.100": {
    "value": "#F0F0F0",
    "variable": "var(--colors-gray-100)"
  },
  "colors.gray.150": {
    "value": "#E7E7E7",
    "variable": "var(--colors-gray-150)"
  },
  "colors.gray.200": {
    "value": "#DEDEDE",
    "variable": "var(--colors-gray-200)"
  },
  "colors.gray.250": {
    "value": "#D4D4D4",
    "variable": "var(--colors-gray-250)"
  },
  "colors.gray.300": {
    "value": "#CACACA",
    "variable": "var(--colors-gray-300)"
  },
  "colors.gray.350": {
    "value": "#C1C1C1",
    "variable": "var(--colors-gray-350)"
  },
  "colors.gray.400": {
    "value": "#B7B7B7",
    "variable": "var(--colors-gray-400)"
  },
  "colors.gray.450": {
    "value": "#AEAEAE",
    "variable": "var(--colors-gray-450)"
  },
  "colors.gray.500": {
    "value": "#727272",
    "variable": "var(--colors-gray-500)"
  },
  "colors.gray.550": {
    "value": "#676767",
    "variable": "var(--colors-gray-550)"
  },
  "colors.gray.600": {
    "value": "#5C5C5C",
    "variable": "var(--colors-gray-600)"
  },
  "colors.gray.650": {
    "value": "#515151",
    "variable": "var(--colors-gray-650)"
  },
  "colors.gray.700": {
    "value": "#464646",
    "variable": "var(--colors-gray-700)"
  },
  "colors.gray.750": {
    "value": "#3B3B3B",
    "variable": "var(--colors-gray-750)"
  },
  "colors.gray.800": {
    "value": "#313131",
    "variable": "var(--colors-gray-800)"
  },
  "colors.gray.850": {
    "value": "#272727",
    "variable": "var(--colors-gray-850)"
  },
  "colors.gray.900": {
    "value": "#1C1C1C",
    "variable": "var(--colors-gray-900)"
  },
  "colors.gray.950": {
    "value": "#050505",
    "variable": "var(--colors-gray-950)"
  },
  "colors.gray.1000": {
    "value": "#000000",
    "variable": "var(--colors-gray-1000)"
  },
  "colors.green.0": {
    "value": "#FFFFFF",
    "variable": "var(--colors-green-0)"
  },
  "colors.green.50": {
    "value": "#F0FDF4",
    "variable": "var(--colors-green-50)"
  },
  "colors.green.100": {
    "value": "#DCFCE7",
    "variable": "var(--colors-green-100)"
  },
  "colors.green.150": {
    "value": "#CCFADC",
    "variable": "var(--colors-green-150)"
  },
  "colors.green.200": {
    "value": "#BBF7D0",
    "variable": "var(--colors-green-200)"
  },
  "colors.green.250": {
    "value": "#A0F3BE",
    "variable": "var(--colors-green-250)"
  },
  "colors.green.300": {
    "value": "#86EFAC",
    "variable": "var(--colors-green-300)"
  },
  "colors.green.350": {
    "value": "#68E696",
    "variable": "var(--colors-green-350)"
  },
  "colors.green.400": {
    "value": "#4ADE80",
    "variable": "var(--colors-green-400)"
  },
  "colors.green.450": {
    "value": "#36D26F",
    "variable": "var(--colors-green-450)"
  },
  "colors.green.500": {
    "value": "#22C55E",
    "variable": "var(--colors-green-500)"
  },
  "colors.green.550": {
    "value": "#1CB454",
    "variable": "var(--colors-green-550)"
  },
  "colors.green.600": {
    "value": "#16A34A",
    "variable": "var(--colors-green-600)"
  },
  "colors.green.650": {
    "value": "#169244",
    "variable": "var(--colors-green-650)"
  },
  "colors.green.700": {
    "value": "#15803D",
    "variable": "var(--colors-green-700)"
  },
  "colors.green.750": {
    "value": "#167238",
    "variable": "var(--colors-green-750)"
  },
  "colors.green.800": {
    "value": "#166534",
    "variable": "var(--colors-green-800)"
  },
  "colors.green.850": {
    "value": "#155C30",
    "variable": "var(--colors-green-850)"
  },
  "colors.green.900": {
    "value": "#14532D",
    "variable": "var(--colors-green-900)"
  },
  "colors.green.950": {
    "value": "#0C4022",
    "variable": "var(--colors-green-950)"
  },
  "colors.green.1000": {
    "value": "#052E16",
    "variable": "var(--colors-green-1000)"
  },
  "colors.orange.0": {
    "value": "#FFFFFF",
    "variable": "var(--colors-orange-0)"
  },
  "colors.orange.50": {
    "value": "#FEF8F3",
    "variable": "var(--colors-orange-50)"
  },
  "colors.orange.100": {
    "value": "#FDEADB",
    "variable": "var(--colors-orange-100)"
  },
  "colors.orange.150": {
    "value": "#FBDCC3",
    "variable": "var(--colors-orange-150)"
  },
  "colors.orange.200": {
    "value": "#F9CEAB",
    "variable": "var(--colors-orange-200)"
  },
  "colors.orange.250": {
    "value": "#F8C093",
    "variable": "var(--colors-orange-250)"
  },
  "colors.orange.300": {
    "value": "#F6B27C",
    "variable": "var(--colors-orange-300)"
  },
  "colors.orange.350": {
    "value": "#F5A364",
    "variable": "var(--colors-orange-350)"
  },
  "colors.orange.400": {
    "value": "#F3954C",
    "variable": "var(--colors-orange-400)"
  },
  "colors.orange.450": {
    "value": "#F18734",
    "variable": "var(--colors-orange-450)"
  },
  "colors.orange.500": {
    "value": "#F0791C",
    "variable": "var(--colors-orange-500)"
  },
  "colors.orange.550": {
    "value": "#E36C0F",
    "variable": "var(--colors-orange-550)"
  },
  "colors.orange.600": {
    "value": "#CB610E",
    "variable": "var(--colors-orange-600)"
  },
  "colors.orange.650": {
    "value": "#B3560C",
    "variable": "var(--colors-orange-650)"
  },
  "colors.orange.700": {
    "value": "#9B4A0A",
    "variable": "var(--colors-orange-700)"
  },
  "colors.orange.750": {
    "value": "#833F09",
    "variable": "var(--colors-orange-750)"
  },
  "colors.orange.800": {
    "value": "#6C3307",
    "variable": "var(--colors-orange-800)"
  },
  "colors.orange.850": {
    "value": "#542806",
    "variable": "var(--colors-orange-850)"
  },
  "colors.orange.900": {
    "value": "#3C1D04",
    "variable": "var(--colors-orange-900)"
  },
  "colors.orange.950": {
    "value": "#241102",
    "variable": "var(--colors-orange-950)"
  },
  "colors.orange.1000": {
    "value": "#0C0601",
    "variable": "var(--colors-orange-1000)"
  },
  "colors.purple.0": {
    "value": "#FFFFFF",
    "variable": "var(--colors-purple-0)"
  },
  "colors.purple.50": {
    "value": "#F6F5FD",
    "variable": "var(--colors-purple-50)"
  },
  "colors.purple.100": {
    "value": "#E5E1F8",
    "variable": "var(--colors-purple-100)"
  },
  "colors.purple.150": {
    "value": "#D4CDF4",
    "variable": "var(--colors-purple-150)"
  },
  "colors.purple.200": {
    "value": "#C3B9F0",
    "variable": "var(--colors-purple-200)"
  },
  "colors.purple.250": {
    "value": "#B1A5EB",
    "variable": "var(--colors-purple-250)"
  },
  "colors.purple.300": {
    "value": "#A091E7",
    "variable": "var(--colors-purple-300)"
  },
  "colors.purple.350": {
    "value": "#8F7DE3",
    "variable": "var(--colors-purple-350)"
  },
  "colors.purple.400": {
    "value": "#7E69DE",
    "variable": "var(--colors-purple-400)"
  },
  "colors.purple.450": {
    "value": "#6C55DA",
    "variable": "var(--colors-purple-450)"
  },
  "colors.purple.500": {
    "value": "#5B41D6",
    "variable": "var(--colors-purple-500)"
  },
  "colors.purple.550": {
    "value": "#4A2ED1",
    "variable": "var(--colors-purple-550)"
  },
  "colors.purple.600": {
    "value": "#4329BD",
    "variable": "var(--colors-purple-600)"
  },
  "colors.purple.650": {
    "value": "#3C25AA",
    "variable": "var(--colors-purple-650)"
  },
  "colors.purple.700": {
    "value": "#352196",
    "variable": "var(--colors-purple-700)"
  },
  "colors.purple.750": {
    "value": "#2E1C82",
    "variable": "var(--colors-purple-750)"
  },
  "colors.purple.800": {
    "value": "#27186E",
    "variable": "var(--colors-purple-800)"
  },
  "colors.purple.850": {
    "value": "#20145A",
    "variable": "var(--colors-purple-850)"
  },
  "colors.purple.900": {
    "value": "#190F46",
    "variable": "var(--colors-purple-900)"
  },
  "colors.purple.950": {
    "value": "#120B32",
    "variable": "var(--colors-purple-950)"
  },
  "colors.purple.1000": {
    "value": "#0B071E",
    "variable": "var(--colors-purple-1000)"
  },
  "colors.red.0": {
    "value": "#FFFFFF",
    "variable": "var(--colors-red-0)"
  },
  "colors.red.50": {
    "value": "#FEF4F4",
    "variable": "var(--colors-red-50)"
  },
  "colors.red.100": {
    "value": "#FCDDDE",
    "variable": "var(--colors-red-100)"
  },
  "colors.red.150": {
    "value": "#FBC7C9",
    "variable": "var(--colors-red-150)"
  },
  "colors.red.200": {
    "value": "#F9B0B3",
    "variable": "var(--colors-red-200)"
  },
  "colors.red.250": {
    "value": "#F79A9D",
    "variable": "var(--colors-red-250)"
  },
  "colors.red.300": {
    "value": "#F58388",
    "variable": "var(--colors-red-300)"
  },
  "colors.red.350": {
    "value": "#F36D72",
    "variable": "var(--colors-red-350)"
  },
  "colors.red.400": {
    "value": "#F2565C",
    "variable": "var(--colors-red-400)"
  },
  "colors.red.450": {
    "value": "#F04046",
    "variable": "var(--colors-red-450)"
  },
  "colors.red.500": {
    "value": "#EE2931",
    "variable": "var(--colors-red-500)"
  },
  "colors.red.550": {
    "value": "#EC131B",
    "variable": "var(--colors-red-550)"
  },
  "colors.red.600": {
    "value": "#D61118",
    "variable": "var(--colors-red-600)"
  },
  "colors.red.650": {
    "value": "#BF0F16",
    "variable": "var(--colors-red-650)"
  },
  "colors.red.700": {
    "value": "#A90D13",
    "variable": "var(--colors-red-700)"
  },
  "colors.red.750": {
    "value": "#920C11",
    "variable": "var(--colors-red-750)"
  },
  "colors.red.800": {
    "value": "#7C0A0E",
    "variable": "var(--colors-red-800)"
  },
  "colors.red.850": {
    "value": "#65080C",
    "variable": "var(--colors-red-850)"
  },
  "colors.red.900": {
    "value": "#4F0609",
    "variable": "var(--colors-red-900)"
  },
  "colors.red.950": {
    "value": "#380406",
    "variable": "var(--colors-red-950)"
  },
  "colors.red.1000": {
    "value": "#220304",
    "variable": "var(--colors-red-1000)"
  },
  "colors.slate.0": {
    "value": "#FFFFFF",
    "variable": "var(--colors-slate-0)"
  },
  "colors.slate.50": {
    "value": "#F9FAFB",
    "variable": "var(--colors-slate-50)"
  },
  "colors.slate.100": {
    "value": "#F6F6F8",
    "variable": "var(--colors-slate-100)"
  },
  "colors.slate.150": {
    "value": "#EBECF0",
    "variable": "var(--colors-slate-150)"
  },
  "colors.slate.200": {
    "value": "#DFE3E9",
    "variable": "var(--colors-slate-200)"
  },
  "colors.slate.250": {
    "value": "#D2D8DF",
    "variable": "var(--colors-slate-250)"
  },
  "colors.slate.300": {
    "value": "#C5CDD5",
    "variable": "var(--colors-slate-300)"
  },
  "colors.slate.350": {
    "value": "#B9C2CA",
    "variable": "var(--colors-slate-350)"
  },
  "colors.slate.400": {
    "value": "#ADB7BF",
    "variable": "var(--colors-slate-400)"
  },
  "colors.slate.450": {
    "value": "#8C97A0",
    "variable": "var(--colors-slate-450)"
  },
  "colors.slate.500": {
    "value": "#6C7782",
    "variable": "var(--colors-slate-500)"
  },
  "colors.slate.550": {
    "value": "#636F7B",
    "variable": "var(--colors-slate-550)"
  },
  "colors.slate.600": {
    "value": "#5A6774",
    "variable": "var(--colors-slate-600)"
  },
  "colors.slate.650": {
    "value": "#4E5D6A",
    "variable": "var(--colors-slate-650)"
  },
  "colors.slate.700": {
    "value": "#435261",
    "variable": "var(--colors-slate-700)"
  },
  "colors.slate.750": {
    "value": "#384757",
    "variable": "var(--colors-slate-750)"
  },
  "colors.slate.800": {
    "value": "#2C3C4D",
    "variable": "var(--colors-slate-800)"
  },
  "colors.slate.850": {
    "value": "#203243",
    "variable": "var(--colors-slate-850)"
  },
  "colors.slate.900": {
    "value": "#142739",
    "variable": "var(--colors-slate-900)"
  },
  "colors.slate.950": {
    "value": "#102132",
    "variable": "var(--colors-slate-950)"
  },
  "colors.slate.1000": {
    "value": "#0C1B2B",
    "variable": "var(--colors-slate-1000)"
  },
  "colors.smoke.0": {
    "value": "#FFFFFF",
    "variable": "var(--colors-smoke-0)"
  },
  "colors.smoke.50": {
    "value": "#F5F5F5",
    "variable": "var(--colors-smoke-50)"
  },
  "colors.smoke.100": {
    "value": "#EEEEF0",
    "variable": "var(--colors-smoke-100)"
  },
  "colors.smoke.150": {
    "value": "#E4E5E7",
    "variable": "var(--colors-smoke-150)"
  },
  "colors.smoke.200": {
    "value": "#D9DADE",
    "variable": "var(--colors-smoke-200)"
  },
  "colors.smoke.250": {
    "value": "#CECFD4",
    "variable": "var(--colors-smoke-250)"
  },
  "colors.smoke.300": {
    "value": "#C3C5CA",
    "variable": "var(--colors-smoke-300)"
  },
  "colors.smoke.350": {
    "value": "#B8BAC1",
    "variable": "var(--colors-smoke-350)"
  },
  "colors.smoke.400": {
    "value": "#AEB0B7",
    "variable": "var(--colors-smoke-400)"
  },
  "colors.smoke.450": {
    "value": "#A3A6AE",
    "variable": "var(--colors-smoke-450)"
  },
  "colors.smoke.500": {
    "value": "#646872",
    "variable": "var(--colors-smoke-500)"
  },
  "colors.smoke.550": {
    "value": "#5A5D67",
    "variable": "var(--colors-smoke-550)"
  },
  "colors.smoke.600": {
    "value": "#51545C",
    "variable": "var(--colors-smoke-600)"
  },
  "colors.smoke.650": {
    "value": "#484A51",
    "variable": "var(--colors-smoke-650)"
  },
  "colors.smoke.700": {
    "value": "#3E4046",
    "variable": "var(--colors-smoke-700)"
  },
  "colors.smoke.750": {
    "value": "#34363B",
    "variable": "var(--colors-smoke-750)"
  },
  "colors.smoke.800": {
    "value": "#2A2C31",
    "variable": "var(--colors-smoke-800)"
  },
  "colors.smoke.850": {
    "value": "#202226",
    "variable": "var(--colors-smoke-850)"
  },
  "colors.smoke.900": {
    "value": "#18191C",
    "variable": "var(--colors-smoke-900)"
  },
  "colors.smoke.950": {
    "value": "#050505",
    "variable": "var(--colors-smoke-950)"
  },
  "colors.smoke.1000": {
    "value": "#000000",
    "variable": "var(--colors-smoke-1000)"
  },
  "colors.turquoise.0": {
    "value": "#FFFFFF",
    "variable": "var(--colors-turquoise-0)"
  },
  "colors.turquoise.50": {
    "value": "#F5F5F5",
    "variable": "var(--colors-turquoise-50)"
  },
  "colors.turquoise.100": {
    "value": "#E2F8F8",
    "variable": "var(--colors-turquoise-100)"
  },
  "colors.turquoise.150": {
    "value": "#CCF2F2",
    "variable": "var(--colors-turquoise-150)"
  },
  "colors.turquoise.200": {
    "value": "#B7EDED",
    "variable": "var(--colors-turquoise-200)"
  },
  "colors.turquoise.250": {
    "value": "#A3E8E8",
    "variable": "var(--colors-turquoise-250)"
  },
  "colors.turquoise.300": {
    "value": "#8EE3E3",
    "variable": "var(--colors-turquoise-300)"
  },
  "colors.turquoise.350": {
    "value": "#7ADEDE",
    "variable": "var(--colors-turquoise-350)"
  },
  "colors.turquoise.400": {
    "value": "#51D4D4",
    "variable": "var(--colors-turquoise-400)"
  },
  "colors.turquoise.450": {
    "value": "#30C2C2",
    "variable": "var(--colors-turquoise-450)"
  },
  "colors.turquoise.500": {
    "value": "#1BAEB1",
    "variable": "var(--colors-turquoise-500)"
  },
  "colors.turquoise.550": {
    "value": "#269999",
    "variable": "var(--colors-turquoise-550)"
  },
  "colors.turquoise.600": {
    "value": "#218585",
    "variable": "var(--colors-turquoise-600)"
  },
  "colors.turquoise.650": {
    "value": "#1C7171",
    "variable": "var(--colors-turquoise-650)"
  },
  "colors.turquoise.700": {
    "value": "#175C5C",
    "variable": "var(--colors-turquoise-700)"
  },
  "colors.turquoise.750": {
    "value": "#124848",
    "variable": "var(--colors-turquoise-750)"
  },
  "colors.turquoise.800": {
    "value": "#0D3333",
    "variable": "var(--colors-turquoise-800)"
  },
  "colors.turquoise.850": {
    "value": "#081F1F",
    "variable": "var(--colors-turquoise-850)"
  },
  "colors.turquoise.900": {
    "value": "#021416",
    "variable": "var(--colors-turquoise-900)"
  },
  "colors.turquoise.950": {
    "value": "#010D0E",
    "variable": "var(--colors-turquoise-950)"
  },
  "colors.turquoise.1000": {
    "value": "#020A0A",
    "variable": "var(--colors-turquoise-1000)"
  },
  "colors.vermillon.0": {
    "value": "#FFFFFF",
    "variable": "var(--colors-vermillon-0)"
  },
  "colors.vermillon.50": {
    "value": "#FFF3F5",
    "variable": "var(--colors-vermillon-50)"
  },
  "colors.vermillon.100": {
    "value": "#FEDBE0",
    "variable": "var(--colors-vermillon-100)"
  },
  "colors.vermillon.150": {
    "value": "#FEC3CC",
    "variable": "var(--colors-vermillon-150)"
  },
  "colors.vermillon.200": {
    "value": "#FEABB8",
    "variable": "var(--colors-vermillon-200)"
  },
  "colors.vermillon.250": {
    "value": "#FD93A3",
    "variable": "var(--colors-vermillon-250)"
  },
  "colors.vermillon.300": {
    "value": "#FD7B8F",
    "variable": "var(--colors-vermillon-300)"
  },
  "colors.vermillon.350": {
    "value": "#FD637B",
    "variable": "var(--colors-vermillon-350)"
  },
  "colors.vermillon.400": {
    "value": "#FC4C66",
    "variable": "var(--colors-vermillon-400)"
  },
  "colors.vermillon.450": {
    "value": "#FC3452",
    "variable": "var(--colors-vermillon-450)"
  },
  "colors.vermillon.500": {
    "value": "#FC1C3E",
    "variable": "var(--colors-vermillon-500)"
  },
  "colors.vermillon.550": {
    "value": "#FC1C3E",
    "variable": "var(--colors-vermillon-550)"
  },
  "colors.vermillon.600": {
    "value": "#E30326",
    "variable": "var(--colors-vermillon-600)"
  },
  "colors.vermillon.650": {
    "value": "#CB0322",
    "variable": "var(--colors-vermillon-650)"
  },
  "colors.vermillon.700": {
    "value": "#B3031E",
    "variable": "var(--colors-vermillon-700)"
  },
  "colors.vermillon.750": {
    "value": "#9C021A",
    "variable": "var(--colors-vermillon-750)"
  },
  "colors.vermillon.800": {
    "value": "#840216",
    "variable": "var(--colors-vermillon-800)"
  },
  "colors.vermillon.850": {
    "value": "#6C0212",
    "variable": "var(--colors-vermillon-850)"
  },
  "colors.vermillon.900": {
    "value": "#54010E",
    "variable": "var(--colors-vermillon-900)"
  },
  "colors.vermillon.950": {
    "value": "#3C010A",
    "variable": "var(--colors-vermillon-950)"
  },
  "colors.vermillon.1000": {
    "value": "#240106",
    "variable": "var(--colors-vermillon-1000)"
  },
  "colors.yellow.0": {
    "value": "#FFFFFF",
    "variable": "var(--colors-yellow-0)"
  },
  "colors.yellow.50": {
    "value": "#FFF9F3",
    "variable": "var(--colors-yellow-50)"
  },
  "colors.yellow.100": {
    "value": "#FFF4DB",
    "variable": "var(--colors-yellow-100)"
  },
  "colors.yellow.150": {
    "value": "#FFF1C3",
    "variable": "var(--colors-yellow-150)"
  },
  "colors.yellow.200": {
    "value": "#FFEAAC",
    "variable": "var(--colors-yellow-200)"
  },
  "colors.yellow.250": {
    "value": "#FFE594",
    "variable": "var(--colors-yellow-250)"
  },
  "colors.yellow.300": {
    "value": "#FFE17C",
    "variable": "var(--colors-yellow-300)"
  },
  "colors.yellow.350": {
    "value": "#FFD864",
    "variable": "var(--colors-yellow-350)"
  },
  "colors.yellow.400": {
    "value": "#FFD54C",
    "variable": "var(--colors-yellow-400)"
  },
  "colors.yellow.450": {
    "value": "#FFD035",
    "variable": "var(--colors-yellow-450)"
  },
  "colors.yellow.500": {
    "value": "#FFC71F",
    "variable": "var(--colors-yellow-500)"
  },
  "colors.yellow.550": {
    "value": "#FFBC11",
    "variable": "var(--colors-yellow-550)"
  },
  "colors.yellow.600": {
    "value": "#F3AF0F",
    "variable": "var(--colors-yellow-600)"
  },
  "colors.yellow.650": {
    "value": "#DB9D0E",
    "variable": "var(--colors-yellow-650)"
  },
  "colors.yellow.700": {
    "value": "#C2890D",
    "variable": "var(--colors-yellow-700)"
  },
  "colors.yellow.750": {
    "value": "#AA750C",
    "variable": "var(--colors-yellow-750)"
  },
  "colors.yellow.800": {
    "value": "#91640B",
    "variable": "var(--colors-yellow-800)"
  },
  "colors.yellow.850": {
    "value": "#785109",
    "variable": "var(--colors-yellow-850)"
  },
  "colors.yellow.900": {
    "value": "#603E08",
    "variable": "var(--colors-yellow-900)"
  },
  "colors.yellow.950": {
    "value": "#462806",
    "variable": "var(--colors-yellow-950)"
  },
  "colors.yellow.1000": {
    "value": "#2D1405",
    "variable": "var(--colors-yellow-1000)"
  },
  "shadows.1": {
    "value": "0 2px 4px 0 rgba(0, 0, 0, .04), 0 3px 4px 0 rgba(0, 0, 0, .04), 0 1px 5px 0 rgba(0, 0, 0, .08)",
    "variable": "var(--shadows-1)"
  },
  "shadows.2": {
    "value": "0 6px 10px 0 rgba(0, 0, 0, .04), 0 1px 18px 0 rgba(0, 0, 0, .04), 0 3px 5px 0 rgba(0, 0, 0, .08)",
    "variable": "var(--shadows-2)"
  },
  "shadows.3": {
    "value": "0 12px 17px 2px rgba(0, 0, 0, .04), 0 5px 22px 4px rgba(0, 0, 0, .04), 0 7px 8px 0 rgba(0, 0, 0, .08)",
    "variable": "var(--shadows-3)"
  },
  "fontSizes.xs": {
    "value": "0.6875rem",
    "variable": "var(--font-sizes-xs)"
  },
  "fontSizes.sm": {
    "value": "0.8125rem",
    "variable": "var(--font-sizes-sm)"
  },
  "fontSizes.md": {
    "value": "1rem",
    "variable": "var(--font-sizes-md)"
  },
  "fontSizes.base": {
    "value": "1rem",
    "variable": "var(--font-sizes-base)"
  },
  "fontSizes.lg": {
    "value": "1.125rem",
    "variable": "var(--font-sizes-lg)"
  },
  "fontSizes.xl": {
    "value": "1.5rem",
    "variable": "var(--font-sizes-xl)"
  },
  "fontSizes.2xl": {
    "value": "1.875rem",
    "variable": "var(--font-sizes-2xl)"
  },
  "fontSizes.3xl": {
    "value": "2.25rem",
    "variable": "var(--font-sizes-3xl)"
  },
  "fontSizes.4xl": {
    "value": "3rem",
    "variable": "var(--font-sizes-4xl)"
  },
  "fontSizes.5xl": {
    "value": "3.75rem",
    "variable": "var(--font-sizes-5xl)"
  },
  "fontSizes.6xl": {
    "value": "6rem",
    "variable": "var(--font-sizes-6xl)"
  },
  "fontSizes.xxl": {
    "value": "1.875rem",
    "variable": "var(--font-sizes-xxl)"
  },
  "fontSizes.xxxl": {
    "value": "2.25rem",
    "variable": "var(--font-sizes-xxxl)"
  },
  "fontSizes.jb": {
    "value": "3rem",
    "variable": "var(--font-sizes-jb)"
  },
  "fontSizes.mg": {
    "value": "3.75rem",
    "variable": "var(--font-sizes-mg)"
  },
  "fontWeights.light": {
    "value": "300",
    "variable": "var(--font-weights-light)"
  },
  "fontWeights.regular": {
    "value": "400",
    "variable": "var(--font-weights-regular)"
  },
  "fontWeights.semibold": {
    "value": "500",
    "variable": "var(--font-weights-semibold)"
  },
  "fontWeights.bold": {
    "value": "500",
    "variable": "var(--font-weights-bold)"
  },
  "fontWeights.extrabold": {
    "value": "500",
    "variable": "var(--font-weights-extrabold)"
  },
  "fonts.sans": {
    "value": "var(--fonts-sans)",
    "variable": "var(--fonts-sans)"
  },
  "fonts.serif": {
    "value": "-apple-system-ui-serif, ui-serif, \"Iowan Old Style\", \"Apple Garamond\", \"Georgia\", \"Baskerville\", \"Times New Roman\", \"Droid Serif\", \"Times\", \"Source Serif Pro\", serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
    "variable": "var(--fonts-serif)"
  },
  "fonts.mono": {
    "value": "ui-monospace, SFMono-Regular, ui-monospace, \"Menlo\", \"Consolas\", \"Monaco\", \"Liberation Mono\", \"Lucida Console\", monospace",
    "variable": "var(--fonts-mono)"
  },
  "letterSpacings.1": {
    "value": "-1.2px",
    "variable": "var(--letter-spacings-1)"
  },
  "letterSpacings.2": {
    "value": "-0.8px",
    "variable": "var(--letter-spacings-2)"
  },
  "letterSpacings.3": {
    "value": "-0.4px",
    "variable": "var(--letter-spacings-3)"
  },
  "letterSpacings.4": {
    "value": "-0.2px",
    "variable": "var(--letter-spacings-4)"
  },
  "letterSpacings.6": {
    "value": "0.2px",
    "variable": "var(--letter-spacings-6)"
  },
  "letterSpacings.base": {
    "value": "0px",
    "variable": "var(--letter-spacings-base)"
  },
  "lineHeights.xs": {
    "value": "1rem",
    "variable": "var(--line-heights-xs)"
  },
  "lineHeights.sm": {
    "value": "1.25rem",
    "variable": "var(--line-heights-sm)"
  },
  "lineHeights.base": {
    "value": "1.5rem",
    "variable": "var(--line-heights-base)"
  },
  "lineHeights.md": {
    "value": "1.5rem",
    "variable": "var(--line-heights-md)"
  },
  "lineHeights.lg": {
    "value": "1.75rem",
    "variable": "var(--line-heights-lg)"
  },
  "lineHeights.xl": {
    "value": "2rem",
    "variable": "var(--line-heights-xl)"
  },
  "lineHeights.2xl": {
    "value": "2.25rem",
    "variable": "var(--line-heights-2xl)"
  },
  "lineHeights.3xl": {
    "value": "2.5rem",
    "variable": "var(--line-heights-3xl)"
  },
  "lineHeights.4xl": {
    "value": "3rem",
    "variable": "var(--line-heights-4xl)"
  },
  "lineHeights.5xl": {
    "value": "3.5rem",
    "variable": "var(--line-heights-5xl)"
  },
  "lineHeights.6xl": {
    "value": "4rem",
    "variable": "var(--line-heights-6xl)"
  },
  "lineHeights.xxl": {
    "value": "2.25rem",
    "variable": "var(--line-heights-xxl)"
  },
  "lineHeights.xxxl": {
    "value": "2.5rem",
    "variable": "var(--line-heights-xxxl)"
  },
  "lineHeights.jb": {
    "value": "3rem",
    "variable": "var(--line-heights-jb)"
  },
  "lineHeights.mg": {
    "value": "4rem",
    "variable": "var(--line-heights-mg)"
  },
  "animations.spin": {
    "value": "spin 1.4s linear infinite",
    "variable": "var(--animations-spin)"
  },
  "animations.progress": {
    "value": "progress 1.4s ease-in-out infinite",
    "variable": "var(--animations-progress)"
  },
  "radii.none": {
    "value": "0",
    "variable": "var(--radii-none)"
  },
  "radii.sm": {
    "value": "0.25rem",
    "variable": "var(--radii-sm)"
  },
  "radii.md": {
    "value": "0.375rem",
    "variable": "var(--radii-md)"
  },
  "radii.lg": {
    "value": "0.5rem",
    "variable": "var(--radii-lg)"
  },
  "radii.xl": {
    "value": "0.75rem",
    "variable": "var(--radii-xl)"
  },
  "radii.2xl": {
    "value": "1rem",
    "variable": "var(--radii-2xl)"
  },
  "radii.3xl": {
    "value": "1.5rem",
    "variable": "var(--radii-3xl)"
  },
  "radii.round": {
    "value": "100rem",
    "variable": "var(--radii-round)"
  },
  "spacing.0": {
    "value": "0rem",
    "variable": "var(--spacing-0)"
  },
  "spacing.1": {
    "value": "0.25rem",
    "variable": "var(--spacing-1)"
  },
  "spacing.2": {
    "value": "0.5rem",
    "variable": "var(--spacing-2)"
  },
  "spacing.3": {
    "value": "0.75rem",
    "variable": "var(--spacing-3)"
  },
  "spacing.4": {
    "value": "1rem",
    "variable": "var(--spacing-4)"
  },
  "spacing.5": {
    "value": "1.25rem",
    "variable": "var(--spacing-5)"
  },
  "spacing.6": {
    "value": "1.5rem",
    "variable": "var(--spacing-6)"
  },
  "spacing.7": {
    "value": "1.75rem",
    "variable": "var(--spacing-7)"
  },
  "spacing.8": {
    "value": "2rem",
    "variable": "var(--spacing-8)"
  },
  "spacing.9": {
    "value": "2.25rem",
    "variable": "var(--spacing-9)"
  },
  "spacing.10": {
    "value": "2.5rem",
    "variable": "var(--spacing-10)"
  },
  "spacing.11": {
    "value": "2.75rem",
    "variable": "var(--spacing-11)"
  },
  "spacing.12": {
    "value": "3rem",
    "variable": "var(--spacing-12)"
  },
  "spacing.14": {
    "value": "3.5rem",
    "variable": "var(--spacing-14)"
  },
  "spacing.16": {
    "value": "4rem",
    "variable": "var(--spacing-16)"
  },
  "spacing.18": {
    "value": "4.5rem",
    "variable": "var(--spacing-18)"
  },
  "spacing.20": {
    "value": "5rem",
    "variable": "var(--spacing-20)"
  },
  "spacing.24": {
    "value": "6rem",
    "variable": "var(--spacing-24)"
  },
  "spacing.28": {
    "value": "7rem",
    "variable": "var(--spacing-28)"
  },
  "spacing.32": {
    "value": "8rem",
    "variable": "var(--spacing-32)"
  },
  "spacing.36": {
    "value": "9rem",
    "variable": "var(--spacing-36)"
  },
  "spacing.40": {
    "value": "10rem",
    "variable": "var(--spacing-40)"
  },
  "spacing.44": {
    "value": "11rem",
    "variable": "var(--spacing-44)"
  },
  "spacing.48": {
    "value": "12rem",
    "variable": "var(--spacing-48)"
  },
  "spacing.52": {
    "value": "13rem",
    "variable": "var(--spacing-52)"
  },
  "spacing.56": {
    "value": "14rem",
    "variable": "var(--spacing-56)"
  },
  "spacing.60": {
    "value": "15rem",
    "variable": "var(--spacing-60)"
  },
  "spacing.64": {
    "value": "16rem",
    "variable": "var(--spacing-64)"
  },
  "spacing.72": {
    "value": "18rem",
    "variable": "var(--spacing-72)"
  },
  "spacing.80": {
    "value": "20rem",
    "variable": "var(--spacing-80)"
  },
  "spacing.96": {
    "value": "24rem",
    "variable": "var(--spacing-96)"
  },
  "spacing.0.5": {
    "value": "0.125rem",
    "variable": "var(--spacing-0\\.5)"
  },
  "spacing.1.5": {
    "value": "0.375rem",
    "variable": "var(--spacing-1\\.5)"
  },
  "spacing.2.5": {
    "value": "0.625rem",
    "variable": "var(--spacing-2\\.5)"
  },
  "spacing.3.5": {
    "value": "0.875rem",
    "variable": "var(--spacing-3\\.5)"
  },
  "cursor.click": {
    "value": "pointer",
    "variable": "var(--cursor-click)"
  },
  "cursor.disabled": {
    "value": "not-allowed",
    "variable": "var(--cursor-disabled)"
  },
  "cursor.dragging": {
    "value": "grabbing",
    "variable": "var(--cursor-dragging)"
  },
  "sizes.0": {
    "value": "0rem",
    "variable": "var(--sizes-0)"
  },
  "sizes.1": {
    "value": "0.25rem",
    "variable": "var(--sizes-1)"
  },
  "sizes.2": {
    "value": "0.5rem",
    "variable": "var(--sizes-2)"
  },
  "sizes.3": {
    "value": "0.75rem",
    "variable": "var(--sizes-3)"
  },
  "sizes.4": {
    "value": "1rem",
    "variable": "var(--sizes-4)"
  },
  "sizes.5": {
    "value": "1.25rem",
    "variable": "var(--sizes-5)"
  },
  "sizes.6": {
    "value": "1.5rem",
    "variable": "var(--sizes-6)"
  },
  "sizes.7": {
    "value": "1.75rem",
    "variable": "var(--sizes-7)"
  },
  "sizes.8": {
    "value": "2rem",
    "variable": "var(--sizes-8)"
  },
  "sizes.9": {
    "value": "2.25rem",
    "variable": "var(--sizes-9)"
  },
  "sizes.10": {
    "value": "2.5rem",
    "variable": "var(--sizes-10)"
  },
  "sizes.11": {
    "value": "2.75rem",
    "variable": "var(--sizes-11)"
  },
  "sizes.12": {
    "value": "3rem",
    "variable": "var(--sizes-12)"
  },
  "sizes.14": {
    "value": "3.5rem",
    "variable": "var(--sizes-14)"
  },
  "sizes.16": {
    "value": "4rem",
    "variable": "var(--sizes-16)"
  },
  "sizes.20": {
    "value": "5rem",
    "variable": "var(--sizes-20)"
  },
  "sizes.24": {
    "value": "6rem",
    "variable": "var(--sizes-24)"
  },
  "sizes.28": {
    "value": "7rem",
    "variable": "var(--sizes-28)"
  },
  "sizes.32": {
    "value": "8rem",
    "variable": "var(--sizes-32)"
  },
  "sizes.36": {
    "value": "9rem",
    "variable": "var(--sizes-36)"
  },
  "sizes.40": {
    "value": "10rem",
    "variable": "var(--sizes-40)"
  },
  "sizes.44": {
    "value": "11rem",
    "variable": "var(--sizes-44)"
  },
  "sizes.48": {
    "value": "12rem",
    "variable": "var(--sizes-48)"
  },
  "sizes.52": {
    "value": "13rem",
    "variable": "var(--sizes-52)"
  },
  "sizes.56": {
    "value": "14rem",
    "variable": "var(--sizes-56)"
  },
  "sizes.60": {
    "value": "15rem",
    "variable": "var(--sizes-60)"
  },
  "sizes.64": {
    "value": "16rem",
    "variable": "var(--sizes-64)"
  },
  "sizes.72": {
    "value": "18rem",
    "variable": "var(--sizes-72)"
  },
  "sizes.80": {
    "value": "20rem",
    "variable": "var(--sizes-80)"
  },
  "sizes.96": {
    "value": "24rem",
    "variable": "var(--sizes-96)"
  },
  "sizes.0.5": {
    "value": "0.125rem",
    "variable": "var(--sizes-0\\.5)"
  },
  "sizes.1.5": {
    "value": "0.375rem",
    "variable": "var(--sizes-1\\.5)"
  },
  "sizes.2.5": {
    "value": "0.625rem",
    "variable": "var(--sizes-2\\.5)"
  },
  "sizes.3.5": {
    "value": "0.875rem",
    "variable": "var(--sizes-3\\.5)"
  },
  "sizes.xs": {
    "value": "1.5rem",
    "variable": "var(--sizes-xs)"
  },
  "sizes.sm": {
    "value": "2.25rem",
    "variable": "var(--sizes-sm)"
  },
  "sizes.md": {
    "value": "3rem",
    "variable": "var(--sizes-md)"
  },
  "sizes.lg": {
    "value": "4rem",
    "variable": "var(--sizes-lg)"
  },
  "sizes.xl": {
    "value": "5rem",
    "variable": "var(--sizes-xl)"
  },
  "sizes.2xl": {
    "value": "7rem",
    "variable": "var(--sizes-2xl)"
  },
  "sizes.3xl": {
    "value": "11rem",
    "variable": "var(--sizes-3xl)"
  },
  "sizes.4xl": {
    "value": "15rem",
    "variable": "var(--sizes-4xl)"
  },
  "sizes.5xl": {
    "value": "64rem",
    "variable": "var(--sizes-5xl)"
  },
  "sizes.6xl": {
    "value": "72rem",
    "variable": "var(--sizes-6xl)"
  },
  "sizes.7xl": {
    "value": "80rem",
    "variable": "var(--sizes-7xl)"
  },
  "sizes.8xl": {
    "value": "90rem",
    "variable": "var(--sizes-8xl)"
  },
  "sizes.prose": {
    "value": "65ch",
    "variable": "var(--sizes-prose)"
  },
  "sizes.full": {
    "value": "100%",
    "variable": "var(--sizes-full)"
  },
  "sizes.min": {
    "value": "min-content",
    "variable": "var(--sizes-min)"
  },
  "sizes.max": {
    "value": "max-content",
    "variable": "var(--sizes-max)"
  },
  "sizes.fit": {
    "value": "fit-content",
    "variable": "var(--sizes-fit)"
  },
  "sizes.breakpoint-xs": {
    "value": "320px",
    "variable": "var(--sizes-breakpoint-xs)"
  },
  "sizes.breakpoint-sm": {
    "value": "480px",
    "variable": "var(--sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-ms": {
    "value": "600px",
    "variable": "var(--sizes-breakpoint-ms)"
  },
  "sizes.breakpoint-md": {
    "value": "768px",
    "variable": "var(--sizes-breakpoint-md)"
  },
  "sizes.breakpoint-ml": {
    "value": "960px",
    "variable": "var(--sizes-breakpoint-ml)"
  },
  "sizes.breakpoint-lg": {
    "value": "1024px",
    "variable": "var(--sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "1280px",
    "variable": "var(--sizes-breakpoint-xl)"
  },
  "sizes.breakpoint-xxl": {
    "value": "1330px",
    "variable": "var(--sizes-breakpoint-xxl)"
  },
  "sizes.breakpoint-jb": {
    "value": "1440px",
    "variable": "var(--sizes-breakpoint-jb)"
  },
  "sizes.breakpoint-mobile": {
    "value": "320px",
    "variable": "var(--sizes-breakpoint-mobile)"
  },
  "sizes.breakpoint-mobile-landscape": {
    "value": "480px",
    "variable": "var(--sizes-breakpoint-mobile-landscape)"
  },
  "sizes.breakpoint-tablet": {
    "value": "600px",
    "variable": "var(--sizes-breakpoint-tablet)"
  },
  "sizes.breakpoint-tablet-landscape": {
    "value": "768px",
    "variable": "var(--sizes-breakpoint-tablet-landscape)"
  },
  "sizes.breakpoint-laptop": {
    "value": "960px",
    "variable": "var(--sizes-breakpoint-laptop)"
  },
  "sizes.breakpoint-desktop": {
    "value": "1024px",
    "variable": "var(--sizes-breakpoint-desktop)"
  },
  "sizes.breakpoint-widescreen": {
    "value": "1280px",
    "variable": "var(--sizes-breakpoint-widescreen)"
  },
  "sizes.breakpoint-ultraWide": {
    "value": "1330px",
    "variable": "var(--sizes-breakpoint-ultra-wide)"
  },
  "sizes.breakpoint-fullHD": {
    "value": "1440px",
    "variable": "var(--sizes-breakpoint-full-h-d)"
  },
  "breakpoints.xs": {
    "value": "320px",
    "variable": "var(--breakpoints-xs)"
  },
  "breakpoints.sm": {
    "value": "480px",
    "variable": "var(--breakpoints-sm)"
  },
  "breakpoints.ms": {
    "value": "600px",
    "variable": "var(--breakpoints-ms)"
  },
  "breakpoints.md": {
    "value": "768px",
    "variable": "var(--breakpoints-md)"
  },
  "breakpoints.ml": {
    "value": "960px",
    "variable": "var(--breakpoints-ml)"
  },
  "breakpoints.lg": {
    "value": "1024px",
    "variable": "var(--breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "1280px",
    "variable": "var(--breakpoints-xl)"
  },
  "breakpoints.xxl": {
    "value": "1330px",
    "variable": "var(--breakpoints-xxl)"
  },
  "breakpoints.jb": {
    "value": "1440px",
    "variable": "var(--breakpoints-jb)"
  },
  "breakpoints.mobile": {
    "value": "320px",
    "variable": "var(--breakpoints-mobile)"
  },
  "breakpoints.mobile-landscape": {
    "value": "480px",
    "variable": "var(--breakpoints-mobile-landscape)"
  },
  "breakpoints.tablet": {
    "value": "600px",
    "variable": "var(--breakpoints-tablet)"
  },
  "breakpoints.tablet-landscape": {
    "value": "768px",
    "variable": "var(--breakpoints-tablet-landscape)"
  },
  "breakpoints.laptop": {
    "value": "960px",
    "variable": "var(--breakpoints-laptop)"
  },
  "breakpoints.desktop": {
    "value": "1024px",
    "variable": "var(--breakpoints-desktop)"
  },
  "breakpoints.widescreen": {
    "value": "1280px",
    "variable": "var(--breakpoints-widescreen)"
  },
  "breakpoints.ultraWide": {
    "value": "1330px",
    "variable": "var(--breakpoints-ultra-wide)"
  },
  "breakpoints.fullHD": {
    "value": "1440px",
    "variable": "var(--breakpoints-full-h-d)"
  },
  "opacity.invisible": {
    "value": "0.0",
    "variable": "var(--opacity-invisible)"
  },
  "opacity.transparent": {
    "value": "0.16",
    "variable": "var(--opacity-transparent)"
  },
  "opacity.shadow": {
    "value": "0.32",
    "variable": "var(--opacity-shadow)"
  },
  "opacity.subtle": {
    "value": "0.48",
    "variable": "var(--opacity-subtle)"
  },
  "opacity.translucent": {
    "value": "0.64",
    "variable": "var(--opacity-translucent)"
  },
  "opacity.overlay": {
    "value": "0.8",
    "variable": "var(--opacity-overlay)"
  },
  "opacity.opaque": {
    "value": "1",
    "variable": "var(--opacity-opaque)"
  },
  "radii.xs": {
    "value": "0.125rem",
    "variable": "var(--radii-xs)"
  },
  "radii.4xl": {
    "value": "2rem",
    "variable": "var(--radii-4xl)"
  },
  "radii.full": {
    "value": "9999px",
    "variable": "var(--radii-full)"
  },
  "radii.base": {
    "value": "var(--radii-md)",
    "variable": "var(--radii-base)"
  },
  "radii.popover": {
    "value": "var(--radii-lg)",
    "variable": "var(--radii-popover)"
  },
  "radii.tooltip": {
    "value": "var(--radii-md)",
    "variable": "var(--radii-tooltip)"
  },
  "radii.hoverCard": {
    "value": "var(--radii-lg)",
    "variable": "var(--radii-hover-card)"
  },
  "radii.modal": {
    "value": "var(--radii-xl)",
    "variable": "var(--radii-modal)"
  },
  "radii.drawer": {
    "value": "var(--radii-2xl)",
    "variable": "var(--radii-drawer)"
  },
  "radii.button": {
    "value": "var(--radii-md)",
    "variable": "var(--radii-button)"
  },
  "radii.input": {
    "value": "var(--radii-md)",
    "variable": "var(--radii-input)"
  },
  "radii.menuItem": {
    "value": "var(--radii-lg)",
    "variable": "var(--radii-menu-item)"
  },
  "radii.container-sm": {
    "value": "var(--radii-lg)",
    "variable": "var(--radii-container-sm)"
  },
  "shadows.2xs": {
    "value": "0px 2px 8px 0px rgba(0, 0, 0, 0.08)",
    "variable": "var(--shadows-2xs)"
  },
  "shadows.xs": {
    "value": "0px 2px 4px 0px rgba(0, 0, 0, 0.24)",
    "variable": "var(--shadows-xs)"
  },
  "shadows.sm": {
    "value": "0px 4px 8px 0px rgba(0, 0, 0, 0.24)",
    "variable": "var(--shadows-sm)"
  },
  "shadows.md": {
    "value": "0px 8px 16px 0px rgba(0, 0, 0, 0.24)",
    "variable": "var(--shadows-md)"
  },
  "shadows.lg": {
    "value": "0px 16px 24px 0px rgba(0, 0, 0, 0.24)",
    "variable": "var(--shadows-lg)"
  },
  "shadows.xl": {
    "value": "0px 24px 36px 0px rgba(0, 0, 0, 0.24)",
    "variable": "var(--shadows-xl)"
  },
  "spacing.none": {
    "value": "var(--spacing-0)",
    "variable": "var(--spacing-none)"
  },
  "spacing.2xs": {
    "value": "var(--spacing-1)",
    "variable": "var(--spacing-2xs)"
  },
  "spacing.xs": {
    "value": "var(--spacing-2)",
    "variable": "var(--spacing-xs)"
  },
  "spacing.sm": {
    "value": "var(--spacing-3)",
    "variable": "var(--spacing-sm)"
  },
  "spacing.md": {
    "value": "var(--spacing-4)",
    "variable": "var(--spacing-md)"
  },
  "spacing.lg": {
    "value": "var(--spacing-5)",
    "variable": "var(--spacing-lg)"
  },
  "spacing.xl": {
    "value": "var(--spacing-6)",
    "variable": "var(--spacing-xl)"
  },
  "spacing.2xl": {
    "value": "var(--spacing-9)",
    "variable": "var(--spacing-2xl)"
  },
  "spacing.3xl": {
    "value": "var(--spacing-12)",
    "variable": "var(--spacing-3xl)"
  },
  "spacing.4xl": {
    "value": "var(--spacing-18)",
    "variable": "var(--spacing-4xl)"
  },
  "spacing.xxs": {
    "value": "var(--spacing-1)",
    "variable": "var(--spacing-xxs)"
  },
  "spacing.xxl": {
    "value": "var(--spacing-9)",
    "variable": "var(--spacing-xxl)"
  },
  "spacing.jb": {
    "value": "var(--spacing-12)",
    "variable": "var(--spacing-jb)"
  },
  "spacing.mg": {
    "value": "var(--spacing-18)",
    "variable": "var(--spacing-mg)"
  },
  "fonts.heading": {
    "value": "var(--fonts-sans)",
    "variable": "var(--fonts-heading)"
  },
  "fonts.body": {
    "value": "var(--fonts-sans)",
    "variable": "var(--fonts-body)"
  },
  "sizes.2xs": {
    "value": "1rem",
    "variable": "var(--sizes-2xs)"
  },
  "sizes.container.xs": {
    "value": "320px",
    "variable": "var(--sizes-container-xs)"
  },
  "sizes.container.sm": {
    "value": "480px",
    "variable": "var(--sizes-container-sm)"
  },
  "sizes.container.ms": {
    "value": "600px",
    "variable": "var(--sizes-container-ms)"
  },
  "sizes.container.md": {
    "value": "768px",
    "variable": "var(--sizes-container-md)"
  },
  "sizes.container.ml": {
    "value": "960px",
    "variable": "var(--sizes-container-ml)"
  },
  "sizes.container.lg": {
    "value": "1024px",
    "variable": "var(--sizes-container-lg)"
  },
  "sizes.container.xl": {
    "value": "1280px",
    "variable": "var(--sizes-container-xl)"
  },
  "sizes.container.xxl": {
    "value": "1330px",
    "variable": "var(--sizes-container-xxl)"
  },
  "sizes.container.jb": {
    "value": "1440px",
    "variable": "var(--sizes-container-jb)"
  },
  "sizes.navbar": {
    "value": "var(--sizes-lg)",
    "variable": "var(--sizes-navbar)"
  },
  "zIndex.absoluteTop": {
    "value": "2147483638",
    "variable": "var(--z-index-absolute-top)"
  },
  "zIndex.alert": {
    "value": "4000",
    "variable": "var(--z-index-alert)"
  },
  "zIndex.modal": {
    "value": "3000",
    "variable": "var(--z-index-modal)"
  },
  "zIndex.overlay": {
    "value": "2000",
    "variable": "var(--z-index-overlay)"
  },
  "zIndex.subOverlay": {
    "value": "1000",
    "variable": "var(--z-index-sub-overlay)"
  },
  "zIndex.base": {
    "value": "0",
    "variable": "var(--z-index-base)"
  },
  "colors.secondary.0": {
    "value": "var(--colors-blue-0)",
    "variable": "var(--colors-secondary-0)"
  },
  "colors.secondary.50": {
    "value": "var(--colors-blue-50)",
    "variable": "var(--colors-secondary-50)"
  },
  "colors.secondary.100": {
    "value": "var(--colors-blue-100)",
    "variable": "var(--colors-secondary-100)"
  },
  "colors.secondary.150": {
    "value": "var(--colors-blue-150)",
    "variable": "var(--colors-secondary-150)"
  },
  "colors.secondary.200": {
    "value": "var(--colors-blue-200)",
    "variable": "var(--colors-secondary-200)"
  },
  "colors.secondary.250": {
    "value": "var(--colors-blue-250)",
    "variable": "var(--colors-secondary-250)"
  },
  "colors.secondary.300": {
    "value": "var(--colors-blue-300)",
    "variable": "var(--colors-secondary-300)"
  },
  "colors.secondary.350": {
    "value": "var(--colors-blue-350)",
    "variable": "var(--colors-secondary-350)"
  },
  "colors.secondary.400": {
    "value": "var(--colors-blue-400)",
    "variable": "var(--colors-secondary-400)"
  },
  "colors.secondary.450": {
    "value": "var(--colors-blue-450)",
    "variable": "var(--colors-secondary-450)"
  },
  "colors.secondary.500": {
    "value": "var(--colors-blue-500)",
    "variable": "var(--colors-secondary-500)"
  },
  "colors.secondary.550": {
    "value": "var(--colors-blue-550)",
    "variable": "var(--colors-secondary-550)"
  },
  "colors.secondary.600": {
    "value": "var(--colors-blue-600)",
    "variable": "var(--colors-secondary-600)"
  },
  "colors.secondary.650": {
    "value": "var(--colors-blue-650)",
    "variable": "var(--colors-secondary-650)"
  },
  "colors.secondary.700": {
    "value": "var(--colors-blue-700)",
    "variable": "var(--colors-secondary-700)"
  },
  "colors.secondary.750": {
    "value": "var(--colors-blue-750)",
    "variable": "var(--colors-secondary-750)"
  },
  "colors.secondary.800": {
    "value": "var(--colors-blue-800)",
    "variable": "var(--colors-secondary-800)"
  },
  "colors.secondary.850": {
    "value": "var(--colors-blue-850)",
    "variable": "var(--colors-secondary-850)"
  },
  "colors.secondary.900": {
    "value": "var(--colors-blue-900)",
    "variable": "var(--colors-secondary-900)"
  },
  "colors.secondary.950": {
    "value": "var(--colors-blue-950)",
    "variable": "var(--colors-secondary-950)"
  },
  "colors.secondary.1000": {
    "value": "var(--colors-blue-1000)",
    "variable": "var(--colors-secondary-1000)"
  },
  "colors.secondary": {
    "value": "var(--colors-blue-500)",
    "variable": "var(--colors-secondary)"
  },
  "colors.warning.0": {
    "value": "var(--colors-yellow-0)",
    "variable": "var(--colors-warning-0)"
  },
  "colors.warning.50": {
    "value": "var(--colors-yellow-50)",
    "variable": "var(--colors-warning-50)"
  },
  "colors.warning.100": {
    "value": "var(--colors-yellow-100)",
    "variable": "var(--colors-warning-100)"
  },
  "colors.warning.150": {
    "value": "var(--colors-yellow-150)",
    "variable": "var(--colors-warning-150)"
  },
  "colors.warning.200": {
    "value": "var(--colors-yellow-200)",
    "variable": "var(--colors-warning-200)"
  },
  "colors.warning.250": {
    "value": "var(--colors-yellow-250)",
    "variable": "var(--colors-warning-250)"
  },
  "colors.warning.300": {
    "value": "var(--colors-yellow-300)",
    "variable": "var(--colors-warning-300)"
  },
  "colors.warning.350": {
    "value": "var(--colors-yellow-350)",
    "variable": "var(--colors-warning-350)"
  },
  "colors.warning.400": {
    "value": "var(--colors-yellow-400)",
    "variable": "var(--colors-warning-400)"
  },
  "colors.warning.450": {
    "value": "var(--colors-yellow-450)",
    "variable": "var(--colors-warning-450)"
  },
  "colors.warning.500": {
    "value": "var(--colors-yellow-500)",
    "variable": "var(--colors-warning-500)"
  },
  "colors.warning.550": {
    "value": "var(--colors-yellow-550)",
    "variable": "var(--colors-warning-550)"
  },
  "colors.warning.600": {
    "value": "var(--colors-yellow-600)",
    "variable": "var(--colors-warning-600)"
  },
  "colors.warning.650": {
    "value": "var(--colors-yellow-650)",
    "variable": "var(--colors-warning-650)"
  },
  "colors.warning.700": {
    "value": "var(--colors-yellow-700)",
    "variable": "var(--colors-warning-700)"
  },
  "colors.warning.750": {
    "value": "var(--colors-yellow-750)",
    "variable": "var(--colors-warning-750)"
  },
  "colors.warning.800": {
    "value": "var(--colors-yellow-800)",
    "variable": "var(--colors-warning-800)"
  },
  "colors.warning.850": {
    "value": "var(--colors-yellow-850)",
    "variable": "var(--colors-warning-850)"
  },
  "colors.warning.900": {
    "value": "var(--colors-yellow-900)",
    "variable": "var(--colors-warning-900)"
  },
  "colors.warning.950": {
    "value": "var(--colors-yellow-950)",
    "variable": "var(--colors-warning-950)"
  },
  "colors.warning.1000": {
    "value": "var(--colors-yellow-1000)",
    "variable": "var(--colors-warning-1000)"
  },
  "colors.warning": {
    "value": "var(--colors-yellow-500)",
    "variable": "var(--colors-warning)"
  },
  "colors.danger.0": {
    "value": "var(--colors-red-0)",
    "variable": "var(--colors-danger-0)"
  },
  "colors.danger.50": {
    "value": "var(--colors-red-50)",
    "variable": "var(--colors-danger-50)"
  },
  "colors.danger.100": {
    "value": "var(--colors-red-100)",
    "variable": "var(--colors-danger-100)"
  },
  "colors.danger.150": {
    "value": "var(--colors-red-150)",
    "variable": "var(--colors-danger-150)"
  },
  "colors.danger.200": {
    "value": "var(--colors-red-200)",
    "variable": "var(--colors-danger-200)"
  },
  "colors.danger.250": {
    "value": "var(--colors-red-250)",
    "variable": "var(--colors-danger-250)"
  },
  "colors.danger.300": {
    "value": "var(--colors-red-300)",
    "variable": "var(--colors-danger-300)"
  },
  "colors.danger.350": {
    "value": "var(--colors-red-350)",
    "variable": "var(--colors-danger-350)"
  },
  "colors.danger.400": {
    "value": "var(--colors-red-400)",
    "variable": "var(--colors-danger-400)"
  },
  "colors.danger.450": {
    "value": "var(--colors-red-450)",
    "variable": "var(--colors-danger-450)"
  },
  "colors.danger.500": {
    "value": "var(--colors-red-500)",
    "variable": "var(--colors-danger-500)"
  },
  "colors.danger.550": {
    "value": "var(--colors-red-550)",
    "variable": "var(--colors-danger-550)"
  },
  "colors.danger.600": {
    "value": "var(--colors-red-600)",
    "variable": "var(--colors-danger-600)"
  },
  "colors.danger.650": {
    "value": "var(--colors-red-650)",
    "variable": "var(--colors-danger-650)"
  },
  "colors.danger.700": {
    "value": "var(--colors-red-700)",
    "variable": "var(--colors-danger-700)"
  },
  "colors.danger.750": {
    "value": "var(--colors-red-750)",
    "variable": "var(--colors-danger-750)"
  },
  "colors.danger.800": {
    "value": "var(--colors-red-800)",
    "variable": "var(--colors-danger-800)"
  },
  "colors.danger.850": {
    "value": "var(--colors-red-850)",
    "variable": "var(--colors-danger-850)"
  },
  "colors.danger.900": {
    "value": "var(--colors-red-900)",
    "variable": "var(--colors-danger-900)"
  },
  "colors.danger.950": {
    "value": "var(--colors-red-950)",
    "variable": "var(--colors-danger-950)"
  },
  "colors.danger.1000": {
    "value": "var(--colors-red-1000)",
    "variable": "var(--colors-danger-1000)"
  },
  "colors.danger": {
    "value": "var(--colors-red-500)",
    "variable": "var(--colors-danger)"
  },
  "colors.info.0": {
    "value": "var(--colors-blue-0)",
    "variable": "var(--colors-info-0)"
  },
  "colors.info.50": {
    "value": "var(--colors-blue-50)",
    "variable": "var(--colors-info-50)"
  },
  "colors.info.100": {
    "value": "var(--colors-blue-100)",
    "variable": "var(--colors-info-100)"
  },
  "colors.info.150": {
    "value": "var(--colors-blue-150)",
    "variable": "var(--colors-info-150)"
  },
  "colors.info.200": {
    "value": "var(--colors-blue-200)",
    "variable": "var(--colors-info-200)"
  },
  "colors.info.250": {
    "value": "var(--colors-blue-250)",
    "variable": "var(--colors-info-250)"
  },
  "colors.info.300": {
    "value": "var(--colors-blue-300)",
    "variable": "var(--colors-info-300)"
  },
  "colors.info.350": {
    "value": "var(--colors-blue-350)",
    "variable": "var(--colors-info-350)"
  },
  "colors.info.400": {
    "value": "var(--colors-blue-400)",
    "variable": "var(--colors-info-400)"
  },
  "colors.info.450": {
    "value": "var(--colors-blue-450)",
    "variable": "var(--colors-info-450)"
  },
  "colors.info.500": {
    "value": "var(--colors-blue-500)",
    "variable": "var(--colors-info-500)"
  },
  "colors.info.550": {
    "value": "var(--colors-blue-550)",
    "variable": "var(--colors-info-550)"
  },
  "colors.info.600": {
    "value": "var(--colors-blue-600)",
    "variable": "var(--colors-info-600)"
  },
  "colors.info.650": {
    "value": "var(--colors-blue-650)",
    "variable": "var(--colors-info-650)"
  },
  "colors.info.700": {
    "value": "var(--colors-blue-700)",
    "variable": "var(--colors-info-700)"
  },
  "colors.info.750": {
    "value": "var(--colors-blue-750)",
    "variable": "var(--colors-info-750)"
  },
  "colors.info.800": {
    "value": "var(--colors-blue-800)",
    "variable": "var(--colors-info-800)"
  },
  "colors.info.850": {
    "value": "var(--colors-blue-850)",
    "variable": "var(--colors-info-850)"
  },
  "colors.info.900": {
    "value": "var(--colors-blue-900)",
    "variable": "var(--colors-info-900)"
  },
  "colors.info.950": {
    "value": "var(--colors-blue-950)",
    "variable": "var(--colors-info-950)"
  },
  "colors.info.1000": {
    "value": "var(--colors-blue-1000)",
    "variable": "var(--colors-info-1000)"
  },
  "colors.info": {
    "value": "var(--colors-blue-500)",
    "variable": "var(--colors-info)"
  },
  "colors.waveform.playHead": {
    "value": "var(--colors-surface-primary)",
    "variable": "var(--colors-waveform-play-head)"
  },
  "colors.waveform.playHead.text": {
    "value": "var(--colors-text-primary-inverted)",
    "variable": "var(--colors-waveform-play-head-text)"
  },
  "colors.primary.0": {
    "value": "var(--colors-primary-0)",
    "variable": "var(--colors-primary-0)"
  },
  "colors.primary.50": {
    "value": "var(--colors-primary-50)",
    "variable": "var(--colors-primary-50)"
  },
  "colors.primary.100": {
    "value": "var(--colors-primary-100)",
    "variable": "var(--colors-primary-100)"
  },
  "colors.primary.150": {
    "value": "var(--colors-primary-150)",
    "variable": "var(--colors-primary-150)"
  },
  "colors.primary.200": {
    "value": "var(--colors-primary-200)",
    "variable": "var(--colors-primary-200)"
  },
  "colors.primary.250": {
    "value": "var(--colors-primary-250)",
    "variable": "var(--colors-primary-250)"
  },
  "colors.primary.300": {
    "value": "var(--colors-primary-300)",
    "variable": "var(--colors-primary-300)"
  },
  "colors.primary.350": {
    "value": "var(--colors-primary-350)",
    "variable": "var(--colors-primary-350)"
  },
  "colors.primary.400": {
    "value": "var(--colors-primary-400)",
    "variable": "var(--colors-primary-400)"
  },
  "colors.primary.450": {
    "value": "var(--colors-primary-450)",
    "variable": "var(--colors-primary-450)"
  },
  "colors.primary.500": {
    "value": "var(--colors-primary-500)",
    "variable": "var(--colors-primary-500)"
  },
  "colors.primary.550": {
    "value": "var(--colors-primary-550)",
    "variable": "var(--colors-primary-550)"
  },
  "colors.primary.600": {
    "value": "var(--colors-primary-600)",
    "variable": "var(--colors-primary-600)"
  },
  "colors.primary.650": {
    "value": "var(--colors-primary-650)",
    "variable": "var(--colors-primary-650)"
  },
  "colors.primary.700": {
    "value": "var(--colors-primary-700)",
    "variable": "var(--colors-primary-700)"
  },
  "colors.primary.750": {
    "value": "var(--colors-primary-750)",
    "variable": "var(--colors-primary-750)"
  },
  "colors.primary.800": {
    "value": "var(--colors-primary-800)",
    "variable": "var(--colors-primary-800)"
  },
  "colors.primary.850": {
    "value": "var(--colors-primary-850)",
    "variable": "var(--colors-primary-850)"
  },
  "colors.primary.900": {
    "value": "var(--colors-primary-900)",
    "variable": "var(--colors-primary-900)"
  },
  "colors.primary.950": {
    "value": "var(--colors-primary-950)",
    "variable": "var(--colors-primary-950)"
  },
  "colors.primary.1000": {
    "value": "var(--colors-primary-1000)",
    "variable": "var(--colors-primary-1000)"
  },
  "colors.primary": {
    "value": "var(--colors-primary)",
    "variable": "var(--colors-primary)"
  },
  "colors.neutral.0": {
    "value": "var(--colors-neutral-0)",
    "variable": "var(--colors-neutral-0)"
  },
  "colors.neutral.50": {
    "value": "var(--colors-neutral-50)",
    "variable": "var(--colors-neutral-50)"
  },
  "colors.neutral.100": {
    "value": "var(--colors-neutral-100)",
    "variable": "var(--colors-neutral-100)"
  },
  "colors.neutral.150": {
    "value": "var(--colors-neutral-150)",
    "variable": "var(--colors-neutral-150)"
  },
  "colors.neutral.200": {
    "value": "var(--colors-neutral-200)",
    "variable": "var(--colors-neutral-200)"
  },
  "colors.neutral.250": {
    "value": "var(--colors-neutral-250)",
    "variable": "var(--colors-neutral-250)"
  },
  "colors.neutral.300": {
    "value": "var(--colors-neutral-300)",
    "variable": "var(--colors-neutral-300)"
  },
  "colors.neutral.350": {
    "value": "var(--colors-neutral-350)",
    "variable": "var(--colors-neutral-350)"
  },
  "colors.neutral.400": {
    "value": "var(--colors-neutral-400)",
    "variable": "var(--colors-neutral-400)"
  },
  "colors.neutral.450": {
    "value": "var(--colors-neutral-450)",
    "variable": "var(--colors-neutral-450)"
  },
  "colors.neutral.500": {
    "value": "var(--colors-neutral-500)",
    "variable": "var(--colors-neutral-500)"
  },
  "colors.neutral.550": {
    "value": "var(--colors-neutral-550)",
    "variable": "var(--colors-neutral-550)"
  },
  "colors.neutral.600": {
    "value": "var(--colors-neutral-600)",
    "variable": "var(--colors-neutral-600)"
  },
  "colors.neutral.650": {
    "value": "var(--colors-neutral-650)",
    "variable": "var(--colors-neutral-650)"
  },
  "colors.neutral.700": {
    "value": "var(--colors-neutral-700)",
    "variable": "var(--colors-neutral-700)"
  },
  "colors.neutral.750": {
    "value": "var(--colors-neutral-750)",
    "variable": "var(--colors-neutral-750)"
  },
  "colors.neutral.800": {
    "value": "var(--colors-neutral-800)",
    "variable": "var(--colors-neutral-800)"
  },
  "colors.neutral.850": {
    "value": "var(--colors-neutral-850)",
    "variable": "var(--colors-neutral-850)"
  },
  "colors.neutral.900": {
    "value": "var(--colors-neutral-900)",
    "variable": "var(--colors-neutral-900)"
  },
  "colors.neutral.950": {
    "value": "var(--colors-neutral-950)",
    "variable": "var(--colors-neutral-950)"
  },
  "colors.neutral.1000": {
    "value": "var(--colors-neutral-1000)",
    "variable": "var(--colors-neutral-1000)"
  },
  "colors.neutral": {
    "value": "var(--colors-neutral)",
    "variable": "var(--colors-neutral)"
  },
  "colors.success.0": {
    "value": "var(--colors-success-0)",
    "variable": "var(--colors-success-0)"
  },
  "colors.success.50": {
    "value": "var(--colors-success-50)",
    "variable": "var(--colors-success-50)"
  },
  "colors.success.100": {
    "value": "var(--colors-success-100)",
    "variable": "var(--colors-success-100)"
  },
  "colors.success.150": {
    "value": "var(--colors-success-150)",
    "variable": "var(--colors-success-150)"
  },
  "colors.success.200": {
    "value": "var(--colors-success-200)",
    "variable": "var(--colors-success-200)"
  },
  "colors.success.250": {
    "value": "var(--colors-success-250)",
    "variable": "var(--colors-success-250)"
  },
  "colors.success.300": {
    "value": "var(--colors-success-300)",
    "variable": "var(--colors-success-300)"
  },
  "colors.success.350": {
    "value": "var(--colors-success-350)",
    "variable": "var(--colors-success-350)"
  },
  "colors.success.400": {
    "value": "var(--colors-success-400)",
    "variable": "var(--colors-success-400)"
  },
  "colors.success.450": {
    "value": "var(--colors-success-450)",
    "variable": "var(--colors-success-450)"
  },
  "colors.success.500": {
    "value": "var(--colors-success-500)",
    "variable": "var(--colors-success-500)"
  },
  "colors.success.550": {
    "value": "var(--colors-success-550)",
    "variable": "var(--colors-success-550)"
  },
  "colors.success.600": {
    "value": "var(--colors-success-600)",
    "variable": "var(--colors-success-600)"
  },
  "colors.success.650": {
    "value": "var(--colors-success-650)",
    "variable": "var(--colors-success-650)"
  },
  "colors.success.700": {
    "value": "var(--colors-success-700)",
    "variable": "var(--colors-success-700)"
  },
  "colors.success.750": {
    "value": "var(--colors-success-750)",
    "variable": "var(--colors-success-750)"
  },
  "colors.success.800": {
    "value": "var(--colors-success-800)",
    "variable": "var(--colors-success-800)"
  },
  "colors.success.850": {
    "value": "var(--colors-success-850)",
    "variable": "var(--colors-success-850)"
  },
  "colors.success.900": {
    "value": "var(--colors-success-900)",
    "variable": "var(--colors-success-900)"
  },
  "colors.success.950": {
    "value": "var(--colors-success-950)",
    "variable": "var(--colors-success-950)"
  },
  "colors.success.1000": {
    "value": "var(--colors-success-1000)",
    "variable": "var(--colors-success-1000)"
  },
  "colors.success": {
    "value": "var(--colors-success)",
    "variable": "var(--colors-success)"
  },
  "assets.noiseTexture": {
    "value": "url(data:image/png;base64,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)",
    "variable": "var(--assets-noise-texture)"
  },
  "gradients.hero": {
    "value": "radial-gradient(90.35% 95.74% at 74.24% -39.14%, var(--colors-primary) 0%, var(--colors-bg-high) 100%)",
    "variable": "var(--gradients-hero)"
  },
  "gradients.primary.linear": {
    "value": "linear-gradient(to bottom, color-mix(in srgb, var(--colors-surface-primary-high) 20%, transparent) 0.27%, color-mix(in srgb, var(--colors-surface-primary-disabled) 20%, transparent) 124.5%)",
    "variable": "var(--gradients-primary-linear)"
  },
  "gradients.primary.radial": {
    "value": "radial-gradient(59.47% 47.25% at 50% 0%, color-mix(in srgb, var(--colors-surface-primary-high) 12%, transparent), color-mix(in srgb, var(--colors-surface-primary-disabled) 12%, transparent))",
    "variable": "var(--gradients-primary-radial)"
  },
  "gradients.neutral.linear": {
    "value": "linear-gradient(to bottom, color-mix(in srgb, var(--colors-surface-neutral-high-active) 20%, transparent) 0.46%, color-mix(in srgb, var(--colors-surface-neutral-medium-subtle) 20%, transparent) 121.09%)",
    "variable": "var(--gradients-neutral-linear)"
  },
  "gradients.neutral.radial": {
    "value": "radial-gradient(59.47% 47.25% at 50% 0%, color-mix(in srgb, var(--colors-surface-neutral-high-active) 20%, transparent), color-mix(in srgb, var(--colors-surface-neutral-medium-subtle) 20%, transparent))",
    "variable": "var(--gradients-neutral-radial)"
  },
  "gradients.neutral.background": {
    "value": "radial-gradient(98.18% 64.02% at 54.99% -0.7%, var(--colors-lightings-neutral-start), var(--colors-lightings-neutral-end))",
    "variable": "var(--gradients-neutral-background)"
  },
  "gradients.success.linear": {
    "value": "linear-gradient(to bottom, color-mix(in srgb, var(--colors-surface-success-high) 20%, transparent) 0.27%, color-mix(in srgb, var(--colors-surface-success-disabled) 20%, transparent) 124.5%)",
    "variable": "var(--gradients-success-linear)"
  },
  "gradients.success.radial": {
    "value": "radial-gradient(59.47% 47.25% at 50% 0%, color-mix(in srgb, var(--colors-surface-success-high) 12%, transparent), color-mix(in srgb, var(--colors-surface-success-disabled) 12%, transparent))",
    "variable": "var(--gradients-success-radial)"
  },
  "gradients.warning.linear": {
    "value": "linear-gradient(to bottom, color-mix(in srgb, var(--colors-surface-warning-high) 20%, transparent) 0.54%, color-mix(in srgb, var(--colors-surface-warning-disabled) 20%, transparent) 121.77%)",
    "variable": "var(--gradients-warning-linear)"
  },
  "gradients.warning.radial": {
    "value": "radial-gradient(59.47% 47.25% at 50% 0%, color-mix(in srgb, var(--colors-surface-warning-high) 12%, transparent), color-mix(in srgb, var(--colors-surface-warning-disabled) 12%, transparent))",
    "variable": "var(--gradients-warning-radial)"
  },
  "gradients.danger.linear": {
    "value": "linear-gradient(to bottom, color-mix(in srgb, var(--colors-surface-danger-high) 20%, transparent) 0.54%, color-mix(in srgb, var(--colors-surface-danger-disabled) 20%, transparent) 126.21%)",
    "variable": "var(--gradients-danger-linear)"
  },
  "gradients.danger.radial": {
    "value": "radial-gradient(59.47% 47.25% at 50% 0%, color-mix(in srgb, var(--colors-surface-danger-high) 12%, transparent), color-mix(in srgb, var(--colors-surface-danger-disabled) 12%, transparent))",
    "variable": "var(--gradients-danger-radial)"
  },
  "gradients.info.linear": {
    "value": "linear-gradient(to bottom, color-mix(in srgb, var(--colors-surface-info-high) 20%, transparent) 0.54%, color-mix(in srgb, var(--colors-surface-info-disabled) 20%, transparent) 123.58%)",
    "variable": "var(--gradients-info-linear)"
  },
  "gradients.info.radial": {
    "value": "radial-gradient(59.47% 47.25% at 50% 0%, color-mix(in srgb, var(--colors-surface-info-high) 12%, transparent), color-mix(in srgb, var(--colors-surface-info-disabled) 12%, transparent))",
    "variable": "var(--gradients-info-radial)"
  },
  "gradients.scrimToBottomMask": {
    "value": "linear-gradient(to bottom, black 0%, rgba(0,0,0,0.7) 70%, rgba(0,0,0,0) 100%)",
    "variable": "var(--gradients-scrim-to-bottom-mask)"
  },
  "spacing.-1": {
    "value": "calc(var(--spacing-1) * -1)",
    "variable": "var(--spacing-1)"
  },
  "spacing.-2": {
    "value": "calc(var(--spacing-2) * -1)",
    "variable": "var(--spacing-2)"
  },
  "spacing.-3": {
    "value": "calc(var(--spacing-3) * -1)",
    "variable": "var(--spacing-3)"
  },
  "spacing.-4": {
    "value": "calc(var(--spacing-4) * -1)",
    "variable": "var(--spacing-4)"
  },
  "spacing.-5": {
    "value": "calc(var(--spacing-5) * -1)",
    "variable": "var(--spacing-5)"
  },
  "spacing.-6": {
    "value": "calc(var(--spacing-6) * -1)",
    "variable": "var(--spacing-6)"
  },
  "spacing.-7": {
    "value": "calc(var(--spacing-7) * -1)",
    "variable": "var(--spacing-7)"
  },
  "spacing.-8": {
    "value": "calc(var(--spacing-8) * -1)",
    "variable": "var(--spacing-8)"
  },
  "spacing.-9": {
    "value": "calc(var(--spacing-9) * -1)",
    "variable": "var(--spacing-9)"
  },
  "spacing.-10": {
    "value": "calc(var(--spacing-10) * -1)",
    "variable": "var(--spacing-10)"
  },
  "spacing.-11": {
    "value": "calc(var(--spacing-11) * -1)",
    "variable": "var(--spacing-11)"
  },
  "spacing.-12": {
    "value": "calc(var(--spacing-12) * -1)",
    "variable": "var(--spacing-12)"
  },
  "spacing.-14": {
    "value": "calc(var(--spacing-14) * -1)",
    "variable": "var(--spacing-14)"
  },
  "spacing.-16": {
    "value": "calc(var(--spacing-16) * -1)",
    "variable": "var(--spacing-16)"
  },
  "spacing.-18": {
    "value": "calc(var(--spacing-18) * -1)",
    "variable": "var(--spacing-18)"
  },
  "spacing.-20": {
    "value": "calc(var(--spacing-20) * -1)",
    "variable": "var(--spacing-20)"
  },
  "spacing.-24": {
    "value": "calc(var(--spacing-24) * -1)",
    "variable": "var(--spacing-24)"
  },
  "spacing.-28": {
    "value": "calc(var(--spacing-28) * -1)",
    "variable": "var(--spacing-28)"
  },
  "spacing.-32": {
    "value": "calc(var(--spacing-32) * -1)",
    "variable": "var(--spacing-32)"
  },
  "spacing.-36": {
    "value": "calc(var(--spacing-36) * -1)",
    "variable": "var(--spacing-36)"
  },
  "spacing.-40": {
    "value": "calc(var(--spacing-40) * -1)",
    "variable": "var(--spacing-40)"
  },
  "spacing.-44": {
    "value": "calc(var(--spacing-44) * -1)",
    "variable": "var(--spacing-44)"
  },
  "spacing.-48": {
    "value": "calc(var(--spacing-48) * -1)",
    "variable": "var(--spacing-48)"
  },
  "spacing.-52": {
    "value": "calc(var(--spacing-52) * -1)",
    "variable": "var(--spacing-52)"
  },
  "spacing.-56": {
    "value": "calc(var(--spacing-56) * -1)",
    "variable": "var(--spacing-56)"
  },
  "spacing.-60": {
    "value": "calc(var(--spacing-60) * -1)",
    "variable": "var(--spacing-60)"
  },
  "spacing.-64": {
    "value": "calc(var(--spacing-64) * -1)",
    "variable": "var(--spacing-64)"
  },
  "spacing.-72": {
    "value": "calc(var(--spacing-72) * -1)",
    "variable": "var(--spacing-72)"
  },
  "spacing.-80": {
    "value": "calc(var(--spacing-80) * -1)",
    "variable": "var(--spacing-80)"
  },
  "spacing.-96": {
    "value": "calc(var(--spacing-96) * -1)",
    "variable": "var(--spacing-96)"
  },
  "spacing.-0.5": {
    "value": "calc(var(--spacing-0\\.5) * -1)",
    "variable": "var(--spacing-0\\.5)"
  },
  "spacing.-1.5": {
    "value": "calc(var(--spacing-1\\.5) * -1)",
    "variable": "var(--spacing-1\\.5)"
  },
  "spacing.-2.5": {
    "value": "calc(var(--spacing-2\\.5) * -1)",
    "variable": "var(--spacing-2\\.5)"
  },
  "spacing.-3.5": {
    "value": "calc(var(--spacing-3\\.5) * -1)",
    "variable": "var(--spacing-3\\.5)"
  },
  "spacing.-none": {
    "value": "calc(var(--spacing-none) * -1)",
    "variable": "var(--spacing-none)"
  },
  "spacing.-2xs": {
    "value": "calc(var(--spacing-2xs) * -1)",
    "variable": "var(--spacing-2xs)"
  },
  "spacing.-xs": {
    "value": "calc(var(--spacing-xs) * -1)",
    "variable": "var(--spacing-xs)"
  },
  "spacing.-sm": {
    "value": "calc(var(--spacing-sm) * -1)",
    "variable": "var(--spacing-sm)"
  },
  "spacing.-md": {
    "value": "calc(var(--spacing-md) * -1)",
    "variable": "var(--spacing-md)"
  },
  "spacing.-lg": {
    "value": "calc(var(--spacing-lg) * -1)",
    "variable": "var(--spacing-lg)"
  },
  "spacing.-xl": {
    "value": "calc(var(--spacing-xl) * -1)",
    "variable": "var(--spacing-xl)"
  },
  "spacing.-2xl": {
    "value": "calc(var(--spacing-2xl) * -1)",
    "variable": "var(--spacing-2xl)"
  },
  "spacing.-3xl": {
    "value": "calc(var(--spacing-3xl) * -1)",
    "variable": "var(--spacing-3xl)"
  },
  "spacing.-4xl": {
    "value": "calc(var(--spacing-4xl) * -1)",
    "variable": "var(--spacing-4xl)"
  },
  "spacing.-xxs": {
    "value": "calc(var(--spacing-xxs) * -1)",
    "variable": "var(--spacing-xxs)"
  },
  "spacing.-xxl": {
    "value": "calc(var(--spacing-xxl) * -1)",
    "variable": "var(--spacing-xxl)"
  },
  "spacing.-jb": {
    "value": "calc(var(--spacing-jb) * -1)",
    "variable": "var(--spacing-jb)"
  },
  "spacing.-mg": {
    "value": "calc(var(--spacing-mg) * -1)",
    "variable": "var(--spacing-mg)"
  },
  "borders.base": {
    "value": "var(--borders-base)",
    "variable": "var(--borders-base)"
  },
  "borders.high": {
    "value": "var(--borders-high)",
    "variable": "var(--borders-high)"
  },
  "borders.medium": {
    "value": "var(--borders-medium)",
    "variable": "var(--borders-medium)"
  },
  "borders.low": {
    "value": "var(--borders-low)",
    "variable": "var(--borders-low)"
  },
  "borders.primary": {
    "value": "var(--borders-primary)",
    "variable": "var(--borders-primary)"
  },
  "borders.secondary": {
    "value": "var(--borders-secondary)",
    "variable": "var(--borders-secondary)"
  },
  "borders.danger": {
    "value": "var(--borders-danger)",
    "variable": "var(--borders-danger)"
  },
  "borders.warning": {
    "value": "var(--borders-warning)",
    "variable": "var(--borders-warning)"
  },
  "borders.success": {
    "value": "var(--borders-success)",
    "variable": "var(--borders-success)"
  },
  "shadows.focus": {
    "value": "var(--shadows-focus)",
    "variable": "var(--shadows-focus)"
  },
  "colors.bg.high": {
    "value": "var(--colors-bg-high)",
    "variable": "var(--colors-bg-high)"
  },
  "colors.bg.medium": {
    "value": "var(--colors-bg-medium)",
    "variable": "var(--colors-bg-medium)"
  },
  "colors.bg.low": {
    "value": "var(--colors-bg-low)",
    "variable": "var(--colors-bg-low)"
  },
  "colors.lightings.neutral.start": {
    "value": "var(--colors-lightings-neutral-start)",
    "variable": "var(--colors-lightings-neutral-start)"
  },
  "colors.lightings.neutral.end": {
    "value": "var(--colors-lightings-neutral-end)",
    "variable": "var(--colors-lightings-neutral-end)"
  },
  "colors.surface.high": {
    "value": "var(--colors-surface-high)",
    "variable": "var(--colors-surface-high)"
  },
  "colors.surface.medium": {
    "value": "var(--colors-surface-medium)",
    "variable": "var(--colors-surface-medium)"
  },
  "colors.surface.low": {
    "value": "var(--colors-surface-low)",
    "variable": "var(--colors-surface-low)"
  },
  "colors.surface.inverted": {
    "value": "var(--colors-surface-inverted)",
    "variable": "var(--colors-surface-inverted)"
  },
  "colors.surface.overlay": {
    "value": "var(--colors-surface-overlay)",
    "variable": "var(--colors-surface-overlay)"
  },
  "colors.surface.handle": {
    "value": "var(--colors-surface-handle)",
    "variable": "var(--colors-surface-handle)"
  },
  "colors.surface.neutral.high": {
    "value": "var(--colors-surface-neutral-high)",
    "variable": "var(--colors-surface-neutral-high)"
  },
  "colors.surface.neutral.high.subtle": {
    "value": "var(--colors-surface-neutral-high-subtle)",
    "variable": "var(--colors-surface-neutral-high-subtle)"
  },
  "colors.surface.neutral.high.clear": {
    "value": "var(--colors-surface-neutral-high-clear)",
    "variable": "var(--colors-surface-neutral-high-clear)"
  },
  "colors.surface.neutral.high.disabled": {
    "value": "var(--colors-surface-neutral-high-disabled)",
    "variable": "var(--colors-surface-neutral-high-disabled)"
  },
  "colors.surface.neutral.high.hover": {
    "value": "var(--colors-surface-neutral-high-hover)",
    "variable": "var(--colors-surface-neutral-high-hover)"
  },
  "colors.surface.neutral.high.active": {
    "value": "var(--colors-surface-neutral-high-active)",
    "variable": "var(--colors-surface-neutral-high-active)"
  },
  "colors.surface.neutral.medium": {
    "value": "var(--colors-surface-neutral-medium)",
    "variable": "var(--colors-surface-neutral-medium)"
  },
  "colors.surface.neutral.medium.subtle": {
    "value": "var(--colors-surface-neutral-medium-subtle)",
    "variable": "var(--colors-surface-neutral-medium-subtle)"
  },
  "colors.surface.neutral.medium.disabled": {
    "value": "var(--colors-surface-neutral-medium-disabled)",
    "variable": "var(--colors-surface-neutral-medium-disabled)"
  },
  "colors.surface.neutral.medium.hover": {
    "value": "var(--colors-surface-neutral-medium-hover)",
    "variable": "var(--colors-surface-neutral-medium-hover)"
  },
  "colors.surface.neutral.medium.active": {
    "value": "var(--colors-surface-neutral-medium-active)",
    "variable": "var(--colors-surface-neutral-medium-active)"
  },
  "colors.surface.neutral.low": {
    "value": "var(--colors-surface-neutral-low)",
    "variable": "var(--colors-surface-neutral-low)"
  },
  "colors.surface.neutral.low.subtle": {
    "value": "var(--colors-surface-neutral-low-subtle)",
    "variable": "var(--colors-surface-neutral-low-subtle)"
  },
  "colors.surface.neutral.low.disabled": {
    "value": "var(--colors-surface-neutral-low-disabled)",
    "variable": "var(--colors-surface-neutral-low-disabled)"
  },
  "colors.surface.neutral.low.hover": {
    "value": "var(--colors-surface-neutral-low-hover)",
    "variable": "var(--colors-surface-neutral-low-hover)"
  },
  "colors.surface.neutral.low.active": {
    "value": "var(--colors-surface-neutral-low-active)",
    "variable": "var(--colors-surface-neutral-low-active)"
  },
  "colors.surface.primary": {
    "value": "var(--colors-surface-primary)",
    "variable": "var(--colors-surface-primary)"
  },
  "colors.surface.primary.high": {
    "value": "var(--colors-surface-primary-high)",
    "variable": "var(--colors-surface-primary-high)"
  },
  "colors.surface.primary.low": {
    "value": "var(--colors-surface-primary-low)",
    "variable": "var(--colors-surface-primary-low)"
  },
  "colors.surface.primary.subtle": {
    "value": "var(--colors-surface-primary-subtle)",
    "variable": "var(--colors-surface-primary-subtle)"
  },
  "colors.surface.primary.clear": {
    "value": "var(--colors-surface-primary-clear)",
    "variable": "var(--colors-surface-primary-clear)"
  },
  "colors.surface.primary.disabled": {
    "value": "var(--colors-surface-primary-disabled)",
    "variable": "var(--colors-surface-primary-disabled)"
  },
  "colors.surface.primary.hover": {
    "value": "var(--colors-surface-primary-hover)",
    "variable": "var(--colors-surface-primary-hover)"
  },
  "colors.surface.primary.active": {
    "value": "var(--colors-surface-primary-active)",
    "variable": "var(--colors-surface-primary-active)"
  },
  "colors.surface.secondary": {
    "value": "var(--colors-surface-secondary)",
    "variable": "var(--colors-surface-secondary)"
  },
  "colors.surface.secondary.high": {
    "value": "var(--colors-surface-secondary-high)",
    "variable": "var(--colors-surface-secondary-high)"
  },
  "colors.surface.secondary.low": {
    "value": "var(--colors-surface-secondary-low)",
    "variable": "var(--colors-surface-secondary-low)"
  },
  "colors.surface.secondary.subtle": {
    "value": "var(--colors-surface-secondary-subtle)",
    "variable": "var(--colors-surface-secondary-subtle)"
  },
  "colors.surface.secondary.clear": {
    "value": "var(--colors-surface-secondary-clear)",
    "variable": "var(--colors-surface-secondary-clear)"
  },
  "colors.surface.secondary.disabled": {
    "value": "var(--colors-surface-secondary-disabled)",
    "variable": "var(--colors-surface-secondary-disabled)"
  },
  "colors.surface.secondary.hover": {
    "value": "var(--colors-surface-secondary-hover)",
    "variable": "var(--colors-surface-secondary-hover)"
  },
  "colors.surface.secondary.active": {
    "value": "var(--colors-surface-secondary-active)",
    "variable": "var(--colors-surface-secondary-active)"
  },
  "colors.surface.warning": {
    "value": "var(--colors-surface-warning)",
    "variable": "var(--colors-surface-warning)"
  },
  "colors.surface.warning.high": {
    "value": "var(--colors-surface-warning-high)",
    "variable": "var(--colors-surface-warning-high)"
  },
  "colors.surface.warning.low": {
    "value": "var(--colors-surface-warning-low)",
    "variable": "var(--colors-surface-warning-low)"
  },
  "colors.surface.warning.subtle": {
    "value": "var(--colors-surface-warning-subtle)",
    "variable": "var(--colors-surface-warning-subtle)"
  },
  "colors.surface.warning.clear": {
    "value": "var(--colors-surface-warning-clear)",
    "variable": "var(--colors-surface-warning-clear)"
  },
  "colors.surface.warning.disabled": {
    "value": "var(--colors-surface-warning-disabled)",
    "variable": "var(--colors-surface-warning-disabled)"
  },
  "colors.surface.warning.hover": {
    "value": "var(--colors-surface-warning-hover)",
    "variable": "var(--colors-surface-warning-hover)"
  },
  "colors.surface.warning.active": {
    "value": "var(--colors-surface-warning-active)",
    "variable": "var(--colors-surface-warning-active)"
  },
  "colors.surface.danger": {
    "value": "var(--colors-surface-danger)",
    "variable": "var(--colors-surface-danger)"
  },
  "colors.surface.danger.high": {
    "value": "var(--colors-surface-danger-high)",
    "variable": "var(--colors-surface-danger-high)"
  },
  "colors.surface.danger.low": {
    "value": "var(--colors-surface-danger-low)",
    "variable": "var(--colors-surface-danger-low)"
  },
  "colors.surface.danger.subtle": {
    "value": "var(--colors-surface-danger-subtle)",
    "variable": "var(--colors-surface-danger-subtle)"
  },
  "colors.surface.danger.clear": {
    "value": "var(--colors-surface-danger-clear)",
    "variable": "var(--colors-surface-danger-clear)"
  },
  "colors.surface.danger.disabled": {
    "value": "var(--colors-surface-danger-disabled)",
    "variable": "var(--colors-surface-danger-disabled)"
  },
  "colors.surface.danger.hover": {
    "value": "var(--colors-surface-danger-hover)",
    "variable": "var(--colors-surface-danger-hover)"
  },
  "colors.surface.danger.active": {
    "value": "var(--colors-surface-danger-active)",
    "variable": "var(--colors-surface-danger-active)"
  },
  "colors.surface.success": {
    "value": "var(--colors-surface-success)",
    "variable": "var(--colors-surface-success)"
  },
  "colors.surface.success.high": {
    "value": "var(--colors-surface-success-high)",
    "variable": "var(--colors-surface-success-high)"
  },
  "colors.surface.success.low": {
    "value": "var(--colors-surface-success-low)",
    "variable": "var(--colors-surface-success-low)"
  },
  "colors.surface.success.subtle": {
    "value": "var(--colors-surface-success-subtle)",
    "variable": "var(--colors-surface-success-subtle)"
  },
  "colors.surface.success.clear": {
    "value": "var(--colors-surface-success-clear)",
    "variable": "var(--colors-surface-success-clear)"
  },
  "colors.surface.success.disabled": {
    "value": "var(--colors-surface-success-disabled)",
    "variable": "var(--colors-surface-success-disabled)"
  },
  "colors.surface.success.hover": {
    "value": "var(--colors-surface-success-hover)",
    "variable": "var(--colors-surface-success-hover)"
  },
  "colors.surface.success.active": {
    "value": "var(--colors-surface-success-active)",
    "variable": "var(--colors-surface-success-active)"
  },
  "colors.surface.info": {
    "value": "var(--colors-surface-info)",
    "variable": "var(--colors-surface-info)"
  },
  "colors.surface.info.high": {
    "value": "var(--colors-surface-info-high)",
    "variable": "var(--colors-surface-info-high)"
  },
  "colors.surface.info.low": {
    "value": "var(--colors-surface-info-low)",
    "variable": "var(--colors-surface-info-low)"
  },
  "colors.surface.info.subtle": {
    "value": "var(--colors-surface-info-subtle)",
    "variable": "var(--colors-surface-info-subtle)"
  },
  "colors.surface.info.clear": {
    "value": "var(--colors-surface-info-clear)",
    "variable": "var(--colors-surface-info-clear)"
  },
  "colors.surface.info.disabled": {
    "value": "var(--colors-surface-info-disabled)",
    "variable": "var(--colors-surface-info-disabled)"
  },
  "colors.surface.info.hover": {
    "value": "var(--colors-surface-info-hover)",
    "variable": "var(--colors-surface-info-hover)"
  },
  "colors.surface.info.active": {
    "value": "var(--colors-surface-info-active)",
    "variable": "var(--colors-surface-info-active)"
  },
  "colors.text.high": {
    "value": "var(--colors-text-high)",
    "variable": "var(--colors-text-high)"
  },
  "colors.text.medium": {
    "value": "var(--colors-text-medium)",
    "variable": "var(--colors-text-medium)"
  },
  "colors.text.low": {
    "value": "var(--colors-text-low)",
    "variable": "var(--colors-text-low)"
  },
  "colors.text.disabled": {
    "value": "var(--colors-text-disabled)",
    "variable": "var(--colors-text-disabled)"
  },
  "colors.text.inverted": {
    "value": "var(--colors-text-inverted)",
    "variable": "var(--colors-text-inverted)"
  },
  "colors.text.inverted.high": {
    "value": "var(--colors-text-inverted-high)",
    "variable": "var(--colors-text-inverted-high)"
  },
  "colors.text.neutral": {
    "value": "var(--colors-text-neutral)",
    "variable": "var(--colors-text-neutral)"
  },
  "colors.text.neutral.high": {
    "value": "var(--colors-text-neutral-high)",
    "variable": "var(--colors-text-neutral-high)"
  },
  "colors.text.neutral.medium": {
    "value": "var(--colors-text-neutral-medium)",
    "variable": "var(--colors-text-neutral-medium)"
  },
  "colors.text.neutral.inverted": {
    "value": "var(--colors-text-neutral-inverted)",
    "variable": "var(--colors-text-neutral-inverted)"
  },
  "colors.text.neutral.inverted.high": {
    "value": "var(--colors-text-neutral-inverted-high)",
    "variable": "var(--colors-text-neutral-inverted-high)"
  },
  "colors.text.neutral.inverted.medium": {
    "value": "var(--colors-text-neutral-inverted-medium)",
    "variable": "var(--colors-text-neutral-inverted-medium)"
  },
  "colors.text.neutral.disabled": {
    "value": "var(--colors-text-neutral-disabled)",
    "variable": "var(--colors-text-neutral-disabled)"
  },
  "colors.text.neutral.disabled.inverted": {
    "value": "var(--colors-text-neutral-disabled-inverted)",
    "variable": "var(--colors-text-neutral-disabled-inverted)"
  },
  "colors.text.primary": {
    "value": "var(--colors-text-primary)",
    "variable": "var(--colors-text-primary)"
  },
  "colors.text.primary.high": {
    "value": "var(--colors-text-primary-high)",
    "variable": "var(--colors-text-primary-high)"
  },
  "colors.text.primary.low": {
    "value": "var(--colors-text-primary-low)",
    "variable": "var(--colors-text-primary-low)"
  },
  "colors.text.primary.inverted": {
    "value": "var(--colors-text-primary-inverted)",
    "variable": "var(--colors-text-primary-inverted)"
  },
  "colors.text.primary.inverted.high": {
    "value": "var(--colors-text-primary-inverted-high)",
    "variable": "var(--colors-text-primary-inverted-high)"
  },
  "colors.text.primary.inverted.low": {
    "value": "var(--colors-text-primary-inverted-low)",
    "variable": "var(--colors-text-primary-inverted-low)"
  },
  "colors.text.primary.disabled": {
    "value": "var(--colors-text-primary-disabled)",
    "variable": "var(--colors-text-primary-disabled)"
  },
  "colors.text.primary.disabled.inverted": {
    "value": "var(--colors-text-primary-disabled-inverted)",
    "variable": "var(--colors-text-primary-disabled-inverted)"
  },
  "colors.text.secondary": {
    "value": "var(--colors-text-secondary)",
    "variable": "var(--colors-text-secondary)"
  },
  "colors.text.secondary.high": {
    "value": "var(--colors-text-secondary-high)",
    "variable": "var(--colors-text-secondary-high)"
  },
  "colors.text.secondary.low": {
    "value": "var(--colors-text-secondary-low)",
    "variable": "var(--colors-text-secondary-low)"
  },
  "colors.text.secondary.inverted": {
    "value": "var(--colors-text-secondary-inverted)",
    "variable": "var(--colors-text-secondary-inverted)"
  },
  "colors.text.secondary.inverted.high": {
    "value": "var(--colors-text-secondary-inverted-high)",
    "variable": "var(--colors-text-secondary-inverted-high)"
  },
  "colors.text.secondary.disabled": {
    "value": "var(--colors-text-secondary-disabled)",
    "variable": "var(--colors-text-secondary-disabled)"
  },
  "colors.text.secondary.disabled.inverted": {
    "value": "var(--colors-text-secondary-disabled-inverted)",
    "variable": "var(--colors-text-secondary-disabled-inverted)"
  },
  "colors.text.secondary.constant": {
    "value": "var(--colors-text-secondary-constant)",
    "variable": "var(--colors-text-secondary-constant)"
  },
  "colors.text.warning": {
    "value": "var(--colors-text-warning)",
    "variable": "var(--colors-text-warning)"
  },
  "colors.text.warning.high": {
    "value": "var(--colors-text-warning-high)",
    "variable": "var(--colors-text-warning-high)"
  },
  "colors.text.warning.low": {
    "value": "var(--colors-text-warning-low)",
    "variable": "var(--colors-text-warning-low)"
  },
  "colors.text.warning.inverted": {
    "value": "var(--colors-text-warning-inverted)",
    "variable": "var(--colors-text-warning-inverted)"
  },
  "colors.text.warning.inverted.high": {
    "value": "var(--colors-text-warning-inverted-high)",
    "variable": "var(--colors-text-warning-inverted-high)"
  },
  "colors.text.warning.disabled": {
    "value": "var(--colors-text-warning-disabled)",
    "variable": "var(--colors-text-warning-disabled)"
  },
  "colors.text.warning.disabled.inverted": {
    "value": "var(--colors-text-warning-disabled-inverted)",
    "variable": "var(--colors-text-warning-disabled-inverted)"
  },
  "colors.text.danger": {
    "value": "var(--colors-text-danger)",
    "variable": "var(--colors-text-danger)"
  },
  "colors.text.danger.high": {
    "value": "var(--colors-text-danger-high)",
    "variable": "var(--colors-text-danger-high)"
  },
  "colors.text.danger.low": {
    "value": "var(--colors-text-danger-low)",
    "variable": "var(--colors-text-danger-low)"
  },
  "colors.text.danger.inverted": {
    "value": "var(--colors-text-danger-inverted)",
    "variable": "var(--colors-text-danger-inverted)"
  },
  "colors.text.danger.inverted.high": {
    "value": "var(--colors-text-danger-inverted-high)",
    "variable": "var(--colors-text-danger-inverted-high)"
  },
  "colors.text.danger.disabled": {
    "value": "var(--colors-text-danger-disabled)",
    "variable": "var(--colors-text-danger-disabled)"
  },
  "colors.text.danger.disabled.inverted": {
    "value": "var(--colors-text-danger-disabled-inverted)",
    "variable": "var(--colors-text-danger-disabled-inverted)"
  },
  "colors.text.success": {
    "value": "var(--colors-text-success)",
    "variable": "var(--colors-text-success)"
  },
  "colors.text.success.high": {
    "value": "var(--colors-text-success-high)",
    "variable": "var(--colors-text-success-high)"
  },
  "colors.text.success.low": {
    "value": "var(--colors-text-success-low)",
    "variable": "var(--colors-text-success-low)"
  },
  "colors.text.success.inverted": {
    "value": "var(--colors-text-success-inverted)",
    "variable": "var(--colors-text-success-inverted)"
  },
  "colors.text.success.inverted.high": {
    "value": "var(--colors-text-success-inverted-high)",
    "variable": "var(--colors-text-success-inverted-high)"
  },
  "colors.text.success.disabled": {
    "value": "var(--colors-text-success-disabled)",
    "variable": "var(--colors-text-success-disabled)"
  },
  "colors.text.success.disabled.inverted": {
    "value": "var(--colors-text-success-disabled-inverted)",
    "variable": "var(--colors-text-success-disabled-inverted)"
  },
  "colors.text.info": {
    "value": "var(--colors-text-info)",
    "variable": "var(--colors-text-info)"
  },
  "colors.text.info.high": {
    "value": "var(--colors-text-info-high)",
    "variable": "var(--colors-text-info-high)"
  },
  "colors.text.info.low": {
    "value": "var(--colors-text-info-low)",
    "variable": "var(--colors-text-info-low)"
  },
  "colors.text.info.inverted": {
    "value": "var(--colors-text-info-inverted)",
    "variable": "var(--colors-text-info-inverted)"
  },
  "colors.text.info.inverted.high": {
    "value": "var(--colors-text-info-inverted-high)",
    "variable": "var(--colors-text-info-inverted-high)"
  },
  "colors.text.info.disabled": {
    "value": "var(--colors-text-info-disabled)",
    "variable": "var(--colors-text-info-disabled)"
  },
  "colors.text.info.disabled.inverted": {
    "value": "var(--colors-text-info-disabled-inverted)",
    "variable": "var(--colors-text-info-disabled-inverted)"
  },
  "colors.icon.high": {
    "value": "var(--colors-icon-high)",
    "variable": "var(--colors-icon-high)"
  },
  "colors.icon.high.hover": {
    "value": "var(--colors-icon-high-hover)",
    "variable": "var(--colors-icon-high-hover)"
  },
  "colors.icon.medium": {
    "value": "var(--colors-icon-medium)",
    "variable": "var(--colors-icon-medium)"
  },
  "colors.icon.low": {
    "value": "var(--colors-icon-low)",
    "variable": "var(--colors-icon-low)"
  },
  "colors.icon.inverted.high": {
    "value": "var(--colors-icon-inverted-high)",
    "variable": "var(--colors-icon-inverted-high)"
  },
  "colors.icon.disabled": {
    "value": "var(--colors-icon-disabled)",
    "variable": "var(--colors-icon-disabled)"
  },
  "colors.icon.neutral": {
    "value": "var(--colors-icon-neutral)",
    "variable": "var(--colors-icon-neutral)"
  },
  "colors.icon.primary": {
    "value": "var(--colors-icon-primary)",
    "variable": "var(--colors-icon-primary)"
  },
  "colors.icon.primary.hover": {
    "value": "var(--colors-icon-primary-hover)",
    "variable": "var(--colors-icon-primary-hover)"
  },
  "colors.icon.secondary": {
    "value": "var(--colors-icon-secondary)",
    "variable": "var(--colors-icon-secondary)"
  },
  "colors.icon.secondary.hover": {
    "value": "var(--colors-icon-secondary-hover)",
    "variable": "var(--colors-icon-secondary-hover)"
  },
  "colors.icon.warning": {
    "value": "var(--colors-icon-warning)",
    "variable": "var(--colors-icon-warning)"
  },
  "colors.icon.warning.hover": {
    "value": "var(--colors-icon-warning-hover)",
    "variable": "var(--colors-icon-warning-hover)"
  },
  "colors.icon.danger": {
    "value": "var(--colors-icon-danger)",
    "variable": "var(--colors-icon-danger)"
  },
  "colors.icon.danger.hover": {
    "value": "var(--colors-icon-danger-hover)",
    "variable": "var(--colors-icon-danger-hover)"
  },
  "colors.icon.success": {
    "value": "var(--colors-icon-success)",
    "variable": "var(--colors-icon-success)"
  },
  "colors.icon.success.hover": {
    "value": "var(--colors-icon-success-hover)",
    "variable": "var(--colors-icon-success-hover)"
  },
  "colors.icon.info": {
    "value": "var(--colors-icon-info)",
    "variable": "var(--colors-icon-info)"
  },
  "colors.icon.info.hover": {
    "value": "var(--colors-icon-info-hover)",
    "variable": "var(--colors-icon-info-hover)"
  },
  "colors.border": {
    "value": "var(--colors-border)",
    "variable": "var(--colors-border)"
  },
  "colors.border.high": {
    "value": "var(--colors-border-high)",
    "variable": "var(--colors-border-high)"
  },
  "colors.border.medium": {
    "value": "var(--colors-border-medium)",
    "variable": "var(--colors-border-medium)"
  },
  "colors.border.medium.disabled": {
    "value": "var(--colors-border-medium-disabled)",
    "variable": "var(--colors-border-medium-disabled)"
  },
  "colors.border.low": {
    "value": "var(--colors-border-low)",
    "variable": "var(--colors-border-low)"
  },
  "colors.border.inverted": {
    "value": "var(--colors-border-inverted)",
    "variable": "var(--colors-border-inverted)"
  },
  "colors.border.inverted.high": {
    "value": "var(--colors-border-inverted-high)",
    "variable": "var(--colors-border-inverted-high)"
  },
  "colors.border.inverted.medium": {
    "value": "var(--colors-border-inverted-medium)",
    "variable": "var(--colors-border-inverted-medium)"
  },
  "colors.border.handle": {
    "value": "var(--colors-border-handle)",
    "variable": "var(--colors-border-handle)"
  },
  "colors.border.neutral.high": {
    "value": "var(--colors-border-neutral-high)",
    "variable": "var(--colors-border-neutral-high)"
  },
  "colors.border.neutral.medium": {
    "value": "var(--colors-border-neutral-medium)",
    "variable": "var(--colors-border-neutral-medium)"
  },
  "colors.border.neutral.low": {
    "value": "var(--colors-border-neutral-low)",
    "variable": "var(--colors-border-neutral-low)"
  },
  "colors.border.primary": {
    "value": "var(--colors-border-primary)",
    "variable": "var(--colors-border-primary)"
  },
  "colors.border.secondary": {
    "value": "var(--colors-border-secondary)",
    "variable": "var(--colors-border-secondary)"
  },
  "colors.border.warning": {
    "value": "var(--colors-border-warning)",
    "variable": "var(--colors-border-warning)"
  },
  "colors.border.danger": {
    "value": "var(--colors-border-danger)",
    "variable": "var(--colors-border-danger)"
  },
  "colors.border.danger.high": {
    "value": "var(--colors-border-danger-high)",
    "variable": "var(--colors-border-danger-high)"
  },
  "colors.border.danger.medium": {
    "value": "var(--colors-border-danger-medium)",
    "variable": "var(--colors-border-danger-medium)"
  },
  "colors.border.success": {
    "value": "var(--colors-border-success)",
    "variable": "var(--colors-border-success)"
  },
  "colors.border.info": {
    "value": "var(--colors-border-info)",
    "variable": "var(--colors-border-info)"
  },
  "colors.products.mastering.fg": {
    "value": "var(--colors-products-mastering-fg)",
    "variable": "var(--colors-products-mastering-fg)"
  },
  "colors.products.mastering": {
    "value": "var(--colors-products-mastering)",
    "variable": "var(--colors-products-mastering)"
  },
  "colors.products.samples.fg": {
    "value": "var(--colors-products-samples-fg)",
    "variable": "var(--colors-products-samples-fg)"
  },
  "colors.products.samples": {
    "value": "var(--colors-products-samples)",
    "variable": "var(--colors-products-samples)"
  },
  "colors.products.plugins.fg": {
    "value": "var(--colors-products-plugins-fg)",
    "variable": "var(--colors-products-plugins-fg)"
  },
  "colors.products.plugins": {
    "value": "var(--colors-products-plugins)",
    "variable": "var(--colors-products-plugins)"
  },
  "colors.products.collaboration.fg": {
    "value": "var(--colors-products-collaboration-fg)",
    "variable": "var(--colors-products-collaboration-fg)"
  },
  "colors.products.collaboration": {
    "value": "var(--colors-products-collaboration)",
    "variable": "var(--colors-products-collaboration)"
  },
  "colors.products.extras.fg": {
    "value": "var(--colors-products-extras-fg)",
    "variable": "var(--colors-products-extras-fg)"
  },
  "colors.products.extras": {
    "value": "var(--colors-products-extras)",
    "variable": "var(--colors-products-extras)"
  },
  "colors.products.courses.fg": {
    "value": "var(--colors-products-courses-fg)",
    "variable": "var(--colors-products-courses-fg)"
  },
  "colors.products.courses": {
    "value": "var(--colors-products-courses)",
    "variable": "var(--colors-products-courses)"
  },
  "colors.products.distribution.fg": {
    "value": "var(--colors-products-distribution-fg)",
    "variable": "var(--colors-products-distribution-fg)"
  },
  "colors.products.distribution": {
    "value": "var(--colors-products-distribution)",
    "variable": "var(--colors-products-distribution)"
  },
  "colors.products.synchroArts.fg": {
    "value": "var(--colors-products-synchro-arts-fg)",
    "variable": "var(--colors-products-synchro-arts-fg)"
  },
  "colors.products.synchroArts": {
    "value": "var(--colors-products-synchro-arts)",
    "variable": "var(--colors-products-synchro-arts)"
  },
  "colors.products.neutral.fg": {
    "value": "var(--colors-products-neutral-fg)",
    "variable": "var(--colors-products-neutral-fg)"
  },
  "colors.products.neutral": {
    "value": "var(--colors-products-neutral)",
    "variable": "var(--colors-products-neutral)"
  },
  "colors.waveform.original": {
    "value": "var(--colors-waveform-original)",
    "variable": "var(--colors-waveform-original)"
  },
  "colors.waveform.original.played": {
    "value": "var(--colors-waveform-original-played)",
    "variable": "var(--colors-waveform-original-played)"
  },
  "colors.waveform.original.seeking": {
    "value": "var(--colors-waveform-original-seeking)",
    "variable": "var(--colors-waveform-original-seeking)"
  },
  "colors.waveform.master": {
    "value": "var(--colors-waveform-master)",
    "variable": "var(--colors-waveform-master)"
  },
  "colors.waveform.master.played": {
    "value": "var(--colors-waveform-master-played)",
    "variable": "var(--colors-waveform-master-played)"
  },
  "colors.waveform.master.seeking": {
    "value": "var(--colors-waveform-master-seeking)",
    "variable": "var(--colors-waveform-master-seeking)"
  },
  "colors.navbar": {
    "value": "var(--colors-navbar)",
    "variable": "var(--colors-navbar)"
  },
  "colors.sidebar": {
    "value": "var(--colors-sidebar)",
    "variable": "var(--colors-sidebar)"
  },
  "gradients.skeleton": {
    "value": "var(--gradients-skeleton)",
    "variable": "var(--gradients-skeleton)"
  },
  "colors.colorPalette": {
    "value": "var(--colors-color-palette)",
    "variable": "var(--colors-color-palette)"
  },
  "colors.colorPalette.0": {
    "value": "var(--colors-color-palette-0)",
    "variable": "var(--colors-color-palette-0)"
  },
  "colors.colorPalette.50": {
    "value": "var(--colors-color-palette-50)",
    "variable": "var(--colors-color-palette-50)"
  },
  "colors.colorPalette.100": {
    "value": "var(--colors-color-palette-100)",
    "variable": "var(--colors-color-palette-100)"
  },
  "colors.colorPalette.150": {
    "value": "var(--colors-color-palette-150)",
    "variable": "var(--colors-color-palette-150)"
  },
  "colors.colorPalette.200": {
    "value": "var(--colors-color-palette-200)",
    "variable": "var(--colors-color-palette-200)"
  },
  "colors.colorPalette.250": {
    "value": "var(--colors-color-palette-250)",
    "variable": "var(--colors-color-palette-250)"
  },
  "colors.colorPalette.300": {
    "value": "var(--colors-color-palette-300)",
    "variable": "var(--colors-color-palette-300)"
  },
  "colors.colorPalette.350": {
    "value": "var(--colors-color-palette-350)",
    "variable": "var(--colors-color-palette-350)"
  },
  "colors.colorPalette.400": {
    "value": "var(--colors-color-palette-400)",
    "variable": "var(--colors-color-palette-400)"
  },
  "colors.colorPalette.450": {
    "value": "var(--colors-color-palette-450)",
    "variable": "var(--colors-color-palette-450)"
  },
  "colors.colorPalette.500": {
    "value": "var(--colors-color-palette-500)",
    "variable": "var(--colors-color-palette-500)"
  },
  "colors.colorPalette.550": {
    "value": "var(--colors-color-palette-550)",
    "variable": "var(--colors-color-palette-550)"
  },
  "colors.colorPalette.600": {
    "value": "var(--colors-color-palette-600)",
    "variable": "var(--colors-color-palette-600)"
  },
  "colors.colorPalette.650": {
    "value": "var(--colors-color-palette-650)",
    "variable": "var(--colors-color-palette-650)"
  },
  "colors.colorPalette.700": {
    "value": "var(--colors-color-palette-700)",
    "variable": "var(--colors-color-palette-700)"
  },
  "colors.colorPalette.750": {
    "value": "var(--colors-color-palette-750)",
    "variable": "var(--colors-color-palette-750)"
  },
  "colors.colorPalette.800": {
    "value": "var(--colors-color-palette-800)",
    "variable": "var(--colors-color-palette-800)"
  },
  "colors.colorPalette.850": {
    "value": "var(--colors-color-palette-850)",
    "variable": "var(--colors-color-palette-850)"
  },
  "colors.colorPalette.900": {
    "value": "var(--colors-color-palette-900)",
    "variable": "var(--colors-color-palette-900)"
  },
  "colors.colorPalette.950": {
    "value": "var(--colors-color-palette-950)",
    "variable": "var(--colors-color-palette-950)"
  },
  "colors.colorPalette.1000": {
    "value": "var(--colors-color-palette-1000)",
    "variable": "var(--colors-color-palette-1000)"
  },
  "colors.colorPalette.high": {
    "value": "var(--colors-color-palette-high)",
    "variable": "var(--colors-color-palette-high)"
  },
  "colors.colorPalette.medium": {
    "value": "var(--colors-color-palette-medium)",
    "variable": "var(--colors-color-palette-medium)"
  },
  "colors.colorPalette.low": {
    "value": "var(--colors-color-palette-low)",
    "variable": "var(--colors-color-palette-low)"
  },
  "colors.colorPalette.neutral.start": {
    "value": "var(--colors-color-palette-neutral-start)",
    "variable": "var(--colors-color-palette-neutral-start)"
  },
  "colors.colorPalette.start": {
    "value": "var(--colors-color-palette-start)",
    "variable": "var(--colors-color-palette-start)"
  },
  "colors.colorPalette.neutral.end": {
    "value": "var(--colors-color-palette-neutral-end)",
    "variable": "var(--colors-color-palette-neutral-end)"
  },
  "colors.colorPalette.end": {
    "value": "var(--colors-color-palette-end)",
    "variable": "var(--colors-color-palette-end)"
  },
  "colors.colorPalette.inverted": {
    "value": "var(--colors-color-palette-inverted)",
    "variable": "var(--colors-color-palette-inverted)"
  },
  "colors.colorPalette.overlay": {
    "value": "var(--colors-color-palette-overlay)",
    "variable": "var(--colors-color-palette-overlay)"
  },
  "colors.colorPalette.handle": {
    "value": "var(--colors-color-palette-handle)",
    "variable": "var(--colors-color-palette-handle)"
  },
  "colors.colorPalette.neutral.high": {
    "value": "var(--colors-color-palette-neutral-high)",
    "variable": "var(--colors-color-palette-neutral-high)"
  },
  "colors.colorPalette.neutral.high.subtle": {
    "value": "var(--colors-color-palette-neutral-high-subtle)",
    "variable": "var(--colors-color-palette-neutral-high-subtle)"
  },
  "colors.colorPalette.high.subtle": {
    "value": "var(--colors-color-palette-high-subtle)",
    "variable": "var(--colors-color-palette-high-subtle)"
  },
  "colors.colorPalette.subtle": {
    "value": "var(--colors-color-palette-subtle)",
    "variable": "var(--colors-color-palette-subtle)"
  },
  "colors.colorPalette.neutral.high.clear": {
    "value": "var(--colors-color-palette-neutral-high-clear)",
    "variable": "var(--colors-color-palette-neutral-high-clear)"
  },
  "colors.colorPalette.high.clear": {
    "value": "var(--colors-color-palette-high-clear)",
    "variable": "var(--colors-color-palette-high-clear)"
  },
  "colors.colorPalette.clear": {
    "value": "var(--colors-color-palette-clear)",
    "variable": "var(--colors-color-palette-clear)"
  },
  "colors.colorPalette.neutral.high.disabled": {
    "value": "var(--colors-color-palette-neutral-high-disabled)",
    "variable": "var(--colors-color-palette-neutral-high-disabled)"
  },
  "colors.colorPalette.high.disabled": {
    "value": "var(--colors-color-palette-high-disabled)",
    "variable": "var(--colors-color-palette-high-disabled)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--colors-color-palette-disabled)",
    "variable": "var(--colors-color-palette-disabled)"
  },
  "colors.colorPalette.neutral.high.hover": {
    "value": "var(--colors-color-palette-neutral-high-hover)",
    "variable": "var(--colors-color-palette-neutral-high-hover)"
  },
  "colors.colorPalette.high.hover": {
    "value": "var(--colors-color-palette-high-hover)",
    "variable": "var(--colors-color-palette-high-hover)"
  },
  "colors.colorPalette.hover": {
    "value": "var(--colors-color-palette-hover)",
    "variable": "var(--colors-color-palette-hover)"
  },
  "colors.colorPalette.neutral.high.active": {
    "value": "var(--colors-color-palette-neutral-high-active)",
    "variable": "var(--colors-color-palette-neutral-high-active)"
  },
  "colors.colorPalette.high.active": {
    "value": "var(--colors-color-palette-high-active)",
    "variable": "var(--colors-color-palette-high-active)"
  },
  "colors.colorPalette.active": {
    "value": "var(--colors-color-palette-active)",
    "variable": "var(--colors-color-palette-active)"
  },
  "colors.colorPalette.neutral.medium": {
    "value": "var(--colors-color-palette-neutral-medium)",
    "variable": "var(--colors-color-palette-neutral-medium)"
  },
  "colors.colorPalette.neutral.medium.subtle": {
    "value": "var(--colors-color-palette-neutral-medium-subtle)",
    "variable": "var(--colors-color-palette-neutral-medium-subtle)"
  },
  "colors.colorPalette.medium.subtle": {
    "value": "var(--colors-color-palette-medium-subtle)",
    "variable": "var(--colors-color-palette-medium-subtle)"
  },
  "colors.colorPalette.neutral.medium.disabled": {
    "value": "var(--colors-color-palette-neutral-medium-disabled)",
    "variable": "var(--colors-color-palette-neutral-medium-disabled)"
  },
  "colors.colorPalette.medium.disabled": {
    "value": "var(--colors-color-palette-medium-disabled)",
    "variable": "var(--colors-color-palette-medium-disabled)"
  },
  "colors.colorPalette.neutral.medium.hover": {
    "value": "var(--colors-color-palette-neutral-medium-hover)",
    "variable": "var(--colors-color-palette-neutral-medium-hover)"
  },
  "colors.colorPalette.medium.hover": {
    "value": "var(--colors-color-palette-medium-hover)",
    "variable": "var(--colors-color-palette-medium-hover)"
  },
  "colors.colorPalette.neutral.medium.active": {
    "value": "var(--colors-color-palette-neutral-medium-active)",
    "variable": "var(--colors-color-palette-neutral-medium-active)"
  },
  "colors.colorPalette.medium.active": {
    "value": "var(--colors-color-palette-medium-active)",
    "variable": "var(--colors-color-palette-medium-active)"
  },
  "colors.colorPalette.neutral.low": {
    "value": "var(--colors-color-palette-neutral-low)",
    "variable": "var(--colors-color-palette-neutral-low)"
  },
  "colors.colorPalette.neutral.low.subtle": {
    "value": "var(--colors-color-palette-neutral-low-subtle)",
    "variable": "var(--colors-color-palette-neutral-low-subtle)"
  },
  "colors.colorPalette.low.subtle": {
    "value": "var(--colors-color-palette-low-subtle)",
    "variable": "var(--colors-color-palette-low-subtle)"
  },
  "colors.colorPalette.neutral.low.disabled": {
    "value": "var(--colors-color-palette-neutral-low-disabled)",
    "variable": "var(--colors-color-palette-neutral-low-disabled)"
  },
  "colors.colorPalette.low.disabled": {
    "value": "var(--colors-color-palette-low-disabled)",
    "variable": "var(--colors-color-palette-low-disabled)"
  },
  "colors.colorPalette.neutral.low.hover": {
    "value": "var(--colors-color-palette-neutral-low-hover)",
    "variable": "var(--colors-color-palette-neutral-low-hover)"
  },
  "colors.colorPalette.low.hover": {
    "value": "var(--colors-color-palette-low-hover)",
    "variable": "var(--colors-color-palette-low-hover)"
  },
  "colors.colorPalette.neutral.low.active": {
    "value": "var(--colors-color-palette-neutral-low-active)",
    "variable": "var(--colors-color-palette-neutral-low-active)"
  },
  "colors.colorPalette.low.active": {
    "value": "var(--colors-color-palette-low-active)",
    "variable": "var(--colors-color-palette-low-active)"
  },
  "colors.colorPalette.primary": {
    "value": "var(--colors-color-palette-primary)",
    "variable": "var(--colors-color-palette-primary)"
  },
  "colors.colorPalette.primary.high": {
    "value": "var(--colors-color-palette-primary-high)",
    "variable": "var(--colors-color-palette-primary-high)"
  },
  "colors.colorPalette.primary.low": {
    "value": "var(--colors-color-palette-primary-low)",
    "variable": "var(--colors-color-palette-primary-low)"
  },
  "colors.colorPalette.primary.subtle": {
    "value": "var(--colors-color-palette-primary-subtle)",
    "variable": "var(--colors-color-palette-primary-subtle)"
  },
  "colors.colorPalette.primary.clear": {
    "value": "var(--colors-color-palette-primary-clear)",
    "variable": "var(--colors-color-palette-primary-clear)"
  },
  "colors.colorPalette.primary.disabled": {
    "value": "var(--colors-color-palette-primary-disabled)",
    "variable": "var(--colors-color-palette-primary-disabled)"
  },
  "colors.colorPalette.primary.hover": {
    "value": "var(--colors-color-palette-primary-hover)",
    "variable": "var(--colors-color-palette-primary-hover)"
  },
  "colors.colorPalette.primary.active": {
    "value": "var(--colors-color-palette-primary-active)",
    "variable": "var(--colors-color-palette-primary-active)"
  },
  "colors.colorPalette.secondary": {
    "value": "var(--colors-color-palette-secondary)",
    "variable": "var(--colors-color-palette-secondary)"
  },
  "colors.colorPalette.secondary.high": {
    "value": "var(--colors-color-palette-secondary-high)",
    "variable": "var(--colors-color-palette-secondary-high)"
  },
  "colors.colorPalette.secondary.low": {
    "value": "var(--colors-color-palette-secondary-low)",
    "variable": "var(--colors-color-palette-secondary-low)"
  },
  "colors.colorPalette.secondary.subtle": {
    "value": "var(--colors-color-palette-secondary-subtle)",
    "variable": "var(--colors-color-palette-secondary-subtle)"
  },
  "colors.colorPalette.secondary.clear": {
    "value": "var(--colors-color-palette-secondary-clear)",
    "variable": "var(--colors-color-palette-secondary-clear)"
  },
  "colors.colorPalette.secondary.disabled": {
    "value": "var(--colors-color-palette-secondary-disabled)",
    "variable": "var(--colors-color-palette-secondary-disabled)"
  },
  "colors.colorPalette.secondary.hover": {
    "value": "var(--colors-color-palette-secondary-hover)",
    "variable": "var(--colors-color-palette-secondary-hover)"
  },
  "colors.colorPalette.secondary.active": {
    "value": "var(--colors-color-palette-secondary-active)",
    "variable": "var(--colors-color-palette-secondary-active)"
  },
  "colors.colorPalette.warning": {
    "value": "var(--colors-color-palette-warning)",
    "variable": "var(--colors-color-palette-warning)"
  },
  "colors.colorPalette.warning.high": {
    "value": "var(--colors-color-palette-warning-high)",
    "variable": "var(--colors-color-palette-warning-high)"
  },
  "colors.colorPalette.warning.low": {
    "value": "var(--colors-color-palette-warning-low)",
    "variable": "var(--colors-color-palette-warning-low)"
  },
  "colors.colorPalette.warning.subtle": {
    "value": "var(--colors-color-palette-warning-subtle)",
    "variable": "var(--colors-color-palette-warning-subtle)"
  },
  "colors.colorPalette.warning.clear": {
    "value": "var(--colors-color-palette-warning-clear)",
    "variable": "var(--colors-color-palette-warning-clear)"
  },
  "colors.colorPalette.warning.disabled": {
    "value": "var(--colors-color-palette-warning-disabled)",
    "variable": "var(--colors-color-palette-warning-disabled)"
  },
  "colors.colorPalette.warning.hover": {
    "value": "var(--colors-color-palette-warning-hover)",
    "variable": "var(--colors-color-palette-warning-hover)"
  },
  "colors.colorPalette.warning.active": {
    "value": "var(--colors-color-palette-warning-active)",
    "variable": "var(--colors-color-palette-warning-active)"
  },
  "colors.colorPalette.danger": {
    "value": "var(--colors-color-palette-danger)",
    "variable": "var(--colors-color-palette-danger)"
  },
  "colors.colorPalette.danger.high": {
    "value": "var(--colors-color-palette-danger-high)",
    "variable": "var(--colors-color-palette-danger-high)"
  },
  "colors.colorPalette.danger.low": {
    "value": "var(--colors-color-palette-danger-low)",
    "variable": "var(--colors-color-palette-danger-low)"
  },
  "colors.colorPalette.danger.subtle": {
    "value": "var(--colors-color-palette-danger-subtle)",
    "variable": "var(--colors-color-palette-danger-subtle)"
  },
  "colors.colorPalette.danger.clear": {
    "value": "var(--colors-color-palette-danger-clear)",
    "variable": "var(--colors-color-palette-danger-clear)"
  },
  "colors.colorPalette.danger.disabled": {
    "value": "var(--colors-color-palette-danger-disabled)",
    "variable": "var(--colors-color-palette-danger-disabled)"
  },
  "colors.colorPalette.danger.hover": {
    "value": "var(--colors-color-palette-danger-hover)",
    "variable": "var(--colors-color-palette-danger-hover)"
  },
  "colors.colorPalette.danger.active": {
    "value": "var(--colors-color-palette-danger-active)",
    "variable": "var(--colors-color-palette-danger-active)"
  },
  "colors.colorPalette.success": {
    "value": "var(--colors-color-palette-success)",
    "variable": "var(--colors-color-palette-success)"
  },
  "colors.colorPalette.success.high": {
    "value": "var(--colors-color-palette-success-high)",
    "variable": "var(--colors-color-palette-success-high)"
  },
  "colors.colorPalette.success.low": {
    "value": "var(--colors-color-palette-success-low)",
    "variable": "var(--colors-color-palette-success-low)"
  },
  "colors.colorPalette.success.subtle": {
    "value": "var(--colors-color-palette-success-subtle)",
    "variable": "var(--colors-color-palette-success-subtle)"
  },
  "colors.colorPalette.success.clear": {
    "value": "var(--colors-color-palette-success-clear)",
    "variable": "var(--colors-color-palette-success-clear)"
  },
  "colors.colorPalette.success.disabled": {
    "value": "var(--colors-color-palette-success-disabled)",
    "variable": "var(--colors-color-palette-success-disabled)"
  },
  "colors.colorPalette.success.hover": {
    "value": "var(--colors-color-palette-success-hover)",
    "variable": "var(--colors-color-palette-success-hover)"
  },
  "colors.colorPalette.success.active": {
    "value": "var(--colors-color-palette-success-active)",
    "variable": "var(--colors-color-palette-success-active)"
  },
  "colors.colorPalette.info": {
    "value": "var(--colors-color-palette-info)",
    "variable": "var(--colors-color-palette-info)"
  },
  "colors.colorPalette.info.high": {
    "value": "var(--colors-color-palette-info-high)",
    "variable": "var(--colors-color-palette-info-high)"
  },
  "colors.colorPalette.info.low": {
    "value": "var(--colors-color-palette-info-low)",
    "variable": "var(--colors-color-palette-info-low)"
  },
  "colors.colorPalette.info.subtle": {
    "value": "var(--colors-color-palette-info-subtle)",
    "variable": "var(--colors-color-palette-info-subtle)"
  },
  "colors.colorPalette.info.clear": {
    "value": "var(--colors-color-palette-info-clear)",
    "variable": "var(--colors-color-palette-info-clear)"
  },
  "colors.colorPalette.info.disabled": {
    "value": "var(--colors-color-palette-info-disabled)",
    "variable": "var(--colors-color-palette-info-disabled)"
  },
  "colors.colorPalette.info.hover": {
    "value": "var(--colors-color-palette-info-hover)",
    "variable": "var(--colors-color-palette-info-hover)"
  },
  "colors.colorPalette.info.active": {
    "value": "var(--colors-color-palette-info-active)",
    "variable": "var(--colors-color-palette-info-active)"
  },
  "colors.colorPalette.inverted.high": {
    "value": "var(--colors-color-palette-inverted-high)",
    "variable": "var(--colors-color-palette-inverted-high)"
  },
  "colors.colorPalette.neutral": {
    "value": "var(--colors-color-palette-neutral)",
    "variable": "var(--colors-color-palette-neutral)"
  },
  "colors.colorPalette.neutral.inverted": {
    "value": "var(--colors-color-palette-neutral-inverted)",
    "variable": "var(--colors-color-palette-neutral-inverted)"
  },
  "colors.colorPalette.neutral.inverted.high": {
    "value": "var(--colors-color-palette-neutral-inverted-high)",
    "variable": "var(--colors-color-palette-neutral-inverted-high)"
  },
  "colors.colorPalette.neutral.inverted.medium": {
    "value": "var(--colors-color-palette-neutral-inverted-medium)",
    "variable": "var(--colors-color-palette-neutral-inverted-medium)"
  },
  "colors.colorPalette.inverted.medium": {
    "value": "var(--colors-color-palette-inverted-medium)",
    "variable": "var(--colors-color-palette-inverted-medium)"
  },
  "colors.colorPalette.neutral.disabled": {
    "value": "var(--colors-color-palette-neutral-disabled)",
    "variable": "var(--colors-color-palette-neutral-disabled)"
  },
  "colors.colorPalette.neutral.disabled.inverted": {
    "value": "var(--colors-color-palette-neutral-disabled-inverted)",
    "variable": "var(--colors-color-palette-neutral-disabled-inverted)"
  },
  "colors.colorPalette.disabled.inverted": {
    "value": "var(--colors-color-palette-disabled-inverted)",
    "variable": "var(--colors-color-palette-disabled-inverted)"
  },
  "colors.colorPalette.primary.inverted": {
    "value": "var(--colors-color-palette-primary-inverted)",
    "variable": "var(--colors-color-palette-primary-inverted)"
  },
  "colors.colorPalette.primary.inverted.high": {
    "value": "var(--colors-color-palette-primary-inverted-high)",
    "variable": "var(--colors-color-palette-primary-inverted-high)"
  },
  "colors.colorPalette.primary.inverted.low": {
    "value": "var(--colors-color-palette-primary-inverted-low)",
    "variable": "var(--colors-color-palette-primary-inverted-low)"
  },
  "colors.colorPalette.inverted.low": {
    "value": "var(--colors-color-palette-inverted-low)",
    "variable": "var(--colors-color-palette-inverted-low)"
  },
  "colors.colorPalette.primary.disabled.inverted": {
    "value": "var(--colors-color-palette-primary-disabled-inverted)",
    "variable": "var(--colors-color-palette-primary-disabled-inverted)"
  },
  "colors.colorPalette.secondary.inverted": {
    "value": "var(--colors-color-palette-secondary-inverted)",
    "variable": "var(--colors-color-palette-secondary-inverted)"
  },
  "colors.colorPalette.secondary.inverted.high": {
    "value": "var(--colors-color-palette-secondary-inverted-high)",
    "variable": "var(--colors-color-palette-secondary-inverted-high)"
  },
  "colors.colorPalette.secondary.disabled.inverted": {
    "value": "var(--colors-color-palette-secondary-disabled-inverted)",
    "variable": "var(--colors-color-palette-secondary-disabled-inverted)"
  },
  "colors.colorPalette.secondary.constant": {
    "value": "var(--colors-color-palette-secondary-constant)",
    "variable": "var(--colors-color-palette-secondary-constant)"
  },
  "colors.colorPalette.constant": {
    "value": "var(--colors-color-palette-constant)",
    "variable": "var(--colors-color-palette-constant)"
  },
  "colors.colorPalette.warning.inverted": {
    "value": "var(--colors-color-palette-warning-inverted)",
    "variable": "var(--colors-color-palette-warning-inverted)"
  },
  "colors.colorPalette.warning.inverted.high": {
    "value": "var(--colors-color-palette-warning-inverted-high)",
    "variable": "var(--colors-color-palette-warning-inverted-high)"
  },
  "colors.colorPalette.warning.disabled.inverted": {
    "value": "var(--colors-color-palette-warning-disabled-inverted)",
    "variable": "var(--colors-color-palette-warning-disabled-inverted)"
  },
  "colors.colorPalette.danger.inverted": {
    "value": "var(--colors-color-palette-danger-inverted)",
    "variable": "var(--colors-color-palette-danger-inverted)"
  },
  "colors.colorPalette.danger.inverted.high": {
    "value": "var(--colors-color-palette-danger-inverted-high)",
    "variable": "var(--colors-color-palette-danger-inverted-high)"
  },
  "colors.colorPalette.danger.disabled.inverted": {
    "value": "var(--colors-color-palette-danger-disabled-inverted)",
    "variable": "var(--colors-color-palette-danger-disabled-inverted)"
  },
  "colors.colorPalette.success.inverted": {
    "value": "var(--colors-color-palette-success-inverted)",
    "variable": "var(--colors-color-palette-success-inverted)"
  },
  "colors.colorPalette.success.inverted.high": {
    "value": "var(--colors-color-palette-success-inverted-high)",
    "variable": "var(--colors-color-palette-success-inverted-high)"
  },
  "colors.colorPalette.success.disabled.inverted": {
    "value": "var(--colors-color-palette-success-disabled-inverted)",
    "variable": "var(--colors-color-palette-success-disabled-inverted)"
  },
  "colors.colorPalette.info.inverted": {
    "value": "var(--colors-color-palette-info-inverted)",
    "variable": "var(--colors-color-palette-info-inverted)"
  },
  "colors.colorPalette.info.inverted.high": {
    "value": "var(--colors-color-palette-info-inverted-high)",
    "variable": "var(--colors-color-palette-info-inverted-high)"
  },
  "colors.colorPalette.info.disabled.inverted": {
    "value": "var(--colors-color-palette-info-disabled-inverted)",
    "variable": "var(--colors-color-palette-info-disabled-inverted)"
  },
  "colors.colorPalette.danger.medium": {
    "value": "var(--colors-color-palette-danger-medium)",
    "variable": "var(--colors-color-palette-danger-medium)"
  },
  "colors.colorPalette.mastering.fg": {
    "value": "var(--colors-color-palette-mastering-fg)",
    "variable": "var(--colors-color-palette-mastering-fg)"
  },
  "colors.colorPalette.fg": {
    "value": "var(--colors-color-palette-fg)",
    "variable": "var(--colors-color-palette-fg)"
  },
  "colors.colorPalette.mastering": {
    "value": "var(--colors-color-palette-mastering)",
    "variable": "var(--colors-color-palette-mastering)"
  },
  "colors.colorPalette.samples.fg": {
    "value": "var(--colors-color-palette-samples-fg)",
    "variable": "var(--colors-color-palette-samples-fg)"
  },
  "colors.colorPalette.samples": {
    "value": "var(--colors-color-palette-samples)",
    "variable": "var(--colors-color-palette-samples)"
  },
  "colors.colorPalette.plugins.fg": {
    "value": "var(--colors-color-palette-plugins-fg)",
    "variable": "var(--colors-color-palette-plugins-fg)"
  },
  "colors.colorPalette.plugins": {
    "value": "var(--colors-color-palette-plugins)",
    "variable": "var(--colors-color-palette-plugins)"
  },
  "colors.colorPalette.collaboration.fg": {
    "value": "var(--colors-color-palette-collaboration-fg)",
    "variable": "var(--colors-color-palette-collaboration-fg)"
  },
  "colors.colorPalette.collaboration": {
    "value": "var(--colors-color-palette-collaboration)",
    "variable": "var(--colors-color-palette-collaboration)"
  },
  "colors.colorPalette.extras.fg": {
    "value": "var(--colors-color-palette-extras-fg)",
    "variable": "var(--colors-color-palette-extras-fg)"
  },
  "colors.colorPalette.extras": {
    "value": "var(--colors-color-palette-extras)",
    "variable": "var(--colors-color-palette-extras)"
  },
  "colors.colorPalette.courses.fg": {
    "value": "var(--colors-color-palette-courses-fg)",
    "variable": "var(--colors-color-palette-courses-fg)"
  },
  "colors.colorPalette.courses": {
    "value": "var(--colors-color-palette-courses)",
    "variable": "var(--colors-color-palette-courses)"
  },
  "colors.colorPalette.distribution.fg": {
    "value": "var(--colors-color-palette-distribution-fg)",
    "variable": "var(--colors-color-palette-distribution-fg)"
  },
  "colors.colorPalette.distribution": {
    "value": "var(--colors-color-palette-distribution)",
    "variable": "var(--colors-color-palette-distribution)"
  },
  "colors.colorPalette.synchroArts.fg": {
    "value": "var(--colors-color-palette-synchro-arts-fg)",
    "variable": "var(--colors-color-palette-synchro-arts-fg)"
  },
  "colors.colorPalette.synchroArts": {
    "value": "var(--colors-color-palette-synchro-arts)",
    "variable": "var(--colors-color-palette-synchro-arts)"
  },
  "colors.colorPalette.neutral.fg": {
    "value": "var(--colors-color-palette-neutral-fg)",
    "variable": "var(--colors-color-palette-neutral-fg)"
  },
  "colors.colorPalette.playHead": {
    "value": "var(--colors-color-palette-play-head)",
    "variable": "var(--colors-color-palette-play-head)"
  },
  "colors.colorPalette.playHead.text": {
    "value": "var(--colors-color-palette-play-head-text)",
    "variable": "var(--colors-color-palette-play-head-text)"
  },
  "colors.colorPalette.text": {
    "value": "var(--colors-color-palette-text)",
    "variable": "var(--colors-color-palette-text)"
  },
  "colors.colorPalette.original": {
    "value": "var(--colors-color-palette-original)",
    "variable": "var(--colors-color-palette-original)"
  },
  "colors.colorPalette.original.played": {
    "value": "var(--colors-color-palette-original-played)",
    "variable": "var(--colors-color-palette-original-played)"
  },
  "colors.colorPalette.played": {
    "value": "var(--colors-color-palette-played)",
    "variable": "var(--colors-color-palette-played)"
  },
  "colors.colorPalette.original.seeking": {
    "value": "var(--colors-color-palette-original-seeking)",
    "variable": "var(--colors-color-palette-original-seeking)"
  },
  "colors.colorPalette.seeking": {
    "value": "var(--colors-color-palette-seeking)",
    "variable": "var(--colors-color-palette-seeking)"
  },
  "colors.colorPalette.master": {
    "value": "var(--colors-color-palette-master)",
    "variable": "var(--colors-color-palette-master)"
  },
  "colors.colorPalette.master.played": {
    "value": "var(--colors-color-palette-master-played)",
    "variable": "var(--colors-color-palette-master-played)"
  },
  "colors.colorPalette.master.seeking": {
    "value": "var(--colors-color-palette-master-seeking)",
    "variable": "var(--colors-color-palette-master-seeking)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar